import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import 'LIBRARY/Components/ResourceDetails/resourceDetails.css';
import LibraryApiCall from 'LibraryApiCall';
import React from 'react';
import Pagination from 'react-js-pagination';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ImportBulkUpdateResources from './importBulkUpdateResources';
import { connect } from 'react-redux';
import { Base64 } from 'js-base64';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import ReactToPrint from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ImportResource from './ImportResource/importResource';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import UpdateMultipleAction from './UpdateMultipleAction';
import ViewResourceDetails from './viewResourceDetails';
import EditResourceDetails from './EditResources';
import AddAccessionSeries from './addAccessionSeries';
import AddResourceCopies from './addResourceCopies';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

let resourceTypeData = [
    "Text Book",
    "Reference Book",
    "Atlas",
    "Biography",
    "Book with CD",
    "CD-ROM",
    "Floppy",
    "General",
    "Laboratory Manual",
    "Practical",
    "Practical Manual",
    " Practical Note Book",
    "Text Book(Practical)",
    "Text Book(Theory & Practical)",
    "Question Bank",
    "Project Thesis",
    "Other",
    "Book bank",
    "Bound Volume",
    "Current issue of the journals",
    "Syllabus copy",
    "Previous years question papers copy"
];
let resourceLanguageData = ["English", "Marathi", "Assamese", "Bengali", "Gujarati", "Kannada", "Kashmiri", "Konkani", "Malayalam", "Manipuri", "Oriya", "Punjabi", "Hindi", "Sanskrit", "Sindhi", "Tamil", "Telugu", "Urdu"]
let resourceConditionData = ["Good", "Partially damaged", "Completely Damaged"];
let locationSubLocationData = [];
let categorySubCategoryData = [];
let selectedCheckboxIID = []

class ResourceDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All resource List
            resourceListLoading: false,
            totalResourcesItems: 0,
            resourceDetailsList: {},
            sortedIdArray: [],
            pageIndex: 1,
            limit: "10",

            selectedRows: [],

            // filter
            resourceSearchTitle: '',
            resourceSearchAuthor: '',
            resourceSearchIID: config.institute_id,
            resourceSearchAccessionSeries: [],
            resourceSearchAccessionNumber: '',
            isFilterLoading: false,
            searchAccessionNumberFrom: '',
            searchAccessionNumberTo: '',
            searchMultipleAccessionNumber: [],
            searchAccessionNo: '',

            GetStreamList: {},
            loadingStreamData: false,

            GetLocationList: {},
            loadingLocationData: false,

            GetResourceCategoryList: {},
            loadingResourceCategoryData: false,

            GetPublisherList: {},
            loadingPublisherData: false,

            GetResourceStatusList: {},
            loadingResourceStatusData: false,

            GetInvoiceDataList: {},
            loadingInvoiceData: false,

            GetMultipleAccessionNumberList: {},
            loadingAccessionNumberData: false,

            GetResourceTitleList: [],
            GetResourceAuthorList: [],
            GetResourceDetailsList: [],
            loadingTitleAuthorData: false,

            // VARIABLES TO GET ACCESSION SERIES
            accessionSeriesList: {},

            linkedInstituteArray: {},
            openBulkUpdateResourceModal: false,

            multipleResourcesDetails: [],
            loadingMultipleResourcesData: false,

            //advance filter modal
            advanceFilterModal: false,
            departmentAdvanceFilterValue: [],
            categoryAdvanceFilterValue: [],
            locationAdvanceFilterValue: [],
            typeAdvanceFilterValue: [],
            statusAdvanceFilterValue: [],
            isDonated: false,

            // update donor modal
            updateDonorModal: false,
            donorsListData: [],
            selectedDonorName: [],
            loadingDonorsData: false,
            searchByDonorName: '',

            // update parent resource modal
            updateParentResourceModal: false,
            resourceListData: [],
            selectedResourceName: [],
            loadingResourceData: false,
            searchByTitleAuthorName: '',

            addResource: false,
            AccessionSeries: '',
            AccessionNumber: '',
            NoOfCopies: 1,
            AccessionDate: '',
            CallIndexSeries: '',
            CallNumber: '',
            Title: '',
            searchByTitle: '',
            searchByAuthor: '',
            Author: '',
            ResourceVolume: '',
            ResourceEdition: '',
            ResourceLanguage: '',
            Publisher: '',
            NumberOfPages: '',
            NumberOfPreliminaryPages: '',
            ResourceCategory: '',
            YearOfPublication: '',
            Department: '',
            ResourceType: '',
            TranslatorName: '',
            Translated: 'Yes',
            SearchKeyword: '',
            Location: '',
            IsbnNumber: '',
            ResourceCondition: { label: 'Good', value: 'Good' },
            MarkAsDonated: '',
            DonorName: '',
            ResourceAttachment: [],
            SpecimenCopy: false,
            InvoiceBillNo: '',
            InvoiceBillDate: '',
            Price: 1,
            Discount: '',
            CopyNetPrice: '',
            TotalCopiesNetPrice: '',
            accessError: '',
            addResourceLoading: false,
            getOnlyParentResource: false,


            GetMaximumLibraryAccessionValue: '',
            loadingGetMaximumLibraryAccession: false,

            libraryCallIndexSeriesList: [],

            // field validation
            accessionSeriesWarning: '',
            accessionNumberWarning: '',
            resourceTitleWarning: '',
            resourceAuthorWarning: '',
            resourceLanguageWarning: '',
            publisherWarning: '',
            resourceCategoryWarning: '',
            resourceTypeWarning: '',
            fileSelectionWarning: '',
            accessionDateWarning: '',
            invoiceDateWarning: '',
            priceWarning: '',

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Accession Series", key: 'accessionSeries' },
                { name: 'Accession Number', key: 'accessionNumber' },
                { name: "Title", key: 'title' },
                { name: "Resource Medium", key: 'resourceMedium' },
                { name: "Author", key: 'author' },
                { name: "Invoice Number", key: 'invoiceNumber' },
                { name: "Resource Status", key: 'resourceStatus' },
                { name: "Resource Edition", key: 'resourceEdition' },
                { name: "Resource Volume", key: 'resourceVolume' }
            ],

            isShowImportResourceButton: false,

            //STATE FOR ACTION
            itemVisibilityForRows: [
                { name: "Update Accession Series", key: 'actionUpdateAccessionSeries', icon: ["fa", "list-alt"] },
                { name: 'Update Resource Location', key: 'actionUpdateResourceLocation', icon: ["fa", "map-marker"] },
                { name: 'Update Resource Category', key: 'actionUpdateResourceCategory', icon: ["fa", "object-group"] },
                { name: "Update Resource Type", key: 'actionUpdateResourceType', icon: ["fa", "book"] },
                { name: "Update Invoice Number", key: 'actionUpdateInvoiceNumber', icon: ["fa", "file"] },
                { name: "Update Resource Status", key: 'actionUpdateResourceStatus', icon: ["fa", "book"] },
                { name: "Update Resource Details", key: 'actionUpdateResourceDetails', icon: ["fa", "edit"] },
                { name: "Update Resource Language", key: 'actionUpdateResourceLanguage', icon: ["fa", "language"] },
                { name: "Mark as donated", key: 'actionMarkAsDonated', icon: ["fa", "handshake"] },
                { name: "Delete Resources", key: 'actionDeleteResources', icon: ["fa", "trash"] },
            ],

            // VARIABLES TO DELETE RESOURCES
            deleteResources: false,
            deletingResources: false,

            // update multiple action
            updateMultipleActionModal: false,

            actionButtonTitle: '',
            allDonorData: [],

            // VARIABLES TO DELETE SINGLE RESOURCES
            deleteSingleResources: false,

            // VARIABLES TO View SINGLE RESOURCES
            viewSingleResources: false,

            // VARIABLES TO EDIT RESOURCES
            editResources: false,

            // VARIABLES TO ADD RESOURCE COPIES
            resourceCopiesModal: false,

            // VARIABLES TO ADD ACCESSION SERIES
            accessionSeriesModal: false,

            singleResourceData: {},

            dataHideWhileExporting: true,

            filterInstituteIID: config.institute_id,
            addResourceInstituteIID: [{
                value: config.institute_id,
                label: this.props?.multipleInstituteDetails?.multipleInstituteDetails?.[config.institute_id]?.institute_name || ''
            }],

            multipleInstituteDetails: this.props.multipleInstituteDetails.multipleInstituteDetails || {},
            typeOfIIDScreen: '',

            loadingFilterAccessionSeries: false,
            filterAccessionSeriesData: [],
            loadingFilterDepartment: false,
            filterDepartmentData: [],
            loadingFilterLocation: false,
            filterLocationData: [],
            loadingFilterResourceCategory: false,
            filterResourceCategoryData: [],
            loadingFilterPublisher: false,
            filterPublisherData: [],
            loadingFilterResourceStatus: false,
            filterResourceStatusData: [],
            loadingFilterInvoice: false,
            filterInvoiceData: [],
            loadingFilterDonor: false,
            filterDonorData: [],

            showActivitySlider: false,
            selectedIid:"",
            hoverID:"",
        };
    }

    componentDidMount() {
        // resource list api call
        this.GetLibraryResourceBasicDetailsList();
        // this.apiCallToGetInstituteStreamList();  // department
        this.apiCallToGetAccessionSeries(); // accession series
        this.GetLibraryLocationList();  // location list
        this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
        this.getPublisherList();  // publisher list
        this.getLibraryResourceStatus();  // resource status
        this.getLibraryInvoiceListDataStatus();  // invoice data
        this.apiCallToGetDonorsList();  // donor data
        this.getInstituteStreamsObject() // department data list

        this.getCallIndexSeriesList();  // library call number series list
        this.formatCSVExportData('onLoad'); // export data
        this.apiCallToGetAllDonorsList();  // All donor data


        // filter API call
        this.apiFilterGetInstituteStreamList();  // department
        this.apiFilterGetAccessionSeries(); // accession series
        this.apiFilterLibraryLocationList();  // location list
        this.apiFilterLibraryResourceCategoryListWithBasicDetails();  // resource category
        this.apiFilterPublisherList();  // publisher list
        this.apiFilterLibraryResourceStatus();  // resource status
        this.apiFilterLibraryInvoiceListDataStatus();  // invoice data
        this.apiFilterGetDonorsList();  // donor data
    }

    // filter API Call 

    //FILTER API CALL TO GET get Institute Stream List 
    apiFilterGetInstituteStreamList = async () => {
        this.setState({
            loadingFilterDepartment: true,
        })

        let multipleInstistuteStreamValue = Array.isArray(this.state.filterInstituteIID)
            ? this.state.filterInstituteIID
            : [this.state.filterInstituteIID];

        let requestData = {
            "iidArray": multipleInstistuteStreamValue
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetMultipleInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    filterDepartmentData: apiResult.data,
                    loadingFilterDepartment: false,
                })
            } else {
                this.setState({
                    loadingFilterDepartment: false,
                })
            }
        }
    }

    //FILTER API CALL METHOD TO GET ACCESSION SERIES
    apiFilterGetAccessionSeries = async () => {
        this.setState({ loadingFilterAccessionSeries: true });

        let accessionSeriesValue = Array.isArray(this.state.filterInstituteIID)
            ? this.state.filterInstituteIID
            : [this.state.filterInstituteIID];

        let requestData = {
            "iid": config.institute_id,
            "iidArray": accessionSeriesValue
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    filterAccessionSeriesData: formattedMembers,
                    loadingFilterAccessionSeries: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingFilterAccessionSeries: false
                });
            }
        }
    }

    //FILTER API CALL TO GET get location List 
    apiFilterLibraryLocationList = async () => {
        this.setState({
            loadingFilterLocation: true,
        })

        let locationValue = Array.isArray(this.state.filterInstituteIID)
            ? this.state.filterInstituteIID
            : [this.state.filterInstituteIID];

        let requestData = {
            iid: config.institute_id,
            iidArray: locationValue
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryLocationList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterLibraryLocationList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const sublocations = [];

                    // If there are sublocations, iterate through them
                    if (seriesData.subLocationCount > 0) {
                        Object.entries(seriesData.sublocation).forEach(([sublocationId, sublocationData]) => {
                            sublocations.push({
                                sublocationId: sublocationId,
                                sublocationName: sublocationData.name
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        sublocations: sublocations // Add sublocation data (if any)
                    };
                });

                this.setState({
                    filterLocationData: formattedData,
                    loadingFilterLocation: false,
                })
            } else {
                this.setState({
                    loadingFilterLocation: false,
                })
            }
        }
    }

    //FILTER API CALL TO GET get resource category List 
    apiFilterLibraryResourceCategoryListWithBasicDetails = async () => {
        this.setState({
            loadingFilterResourceCategory: true,
        })

        let resourceCategoryValue = Array.isArray(this.state.filterInstituteIID)
            ? this.state.filterInstituteIID
            : [this.state.filterInstituteIID];

        let requestData = {
            iid: config.institute_id,
            iidArray: resourceCategoryValue,
            isSortByAscendingCategoryName: "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceCategoryListWithBasicDetails',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterLibraryResourceCategoryListWithBasicDetails();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const subCategories = [];

                    // If there are subCategories, iterate through them
                    if (Object.values(seriesData.subresource).length > 0) {
                        Object.entries(seriesData.subresource).forEach(([subCategoryId, subCategoryData]) => {
                            subCategories.push({
                                subCategoryId: subCategoryId,
                                subCategoryName: subCategoryData.name,
                                parentId: subCategoryData.parentCategoryId
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        subCategories: subCategories // Add subresource data (if any)
                    };
                });


                this.setState({
                    filterResourceCategoryData: formattedData,
                    loadingFilterResourceCategory: false,
                })
            } else {
                this.setState({
                    loadingFilterResourceCategory: false,
                })
            }
        }
    }

    //FILTER API CALL TO GET get publisher List 
    apiFilterPublisherList = async () => {
        this.setState({
            loadingFilterPublisher: true,
        })

        let publisherValue = Array.isArray(this.state.filterInstituteIID)
            ? this.state.filterInstituteIID
            : [this.state.filterInstituteIID];

        let requestData = {
            iid: config.institute_id,
            isOrderByAscendingDisplayName: "true",
            pageIndex: "all",
            limitPerPage: "all",
            iidArray: publisherValue
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPublisherList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterPublisherList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    name: seriesData?.name,
                }));

                this.setState({
                    filterPublisherData: formattedData,
                    loadingFilterPublisher: false,
                })
            } else {
                this.setState({
                    loadingFilterPublisher: false,
                })
            }
        }
    }

    //FILTER API CALL TO GET get resource status List 
    apiFilterLibraryResourceStatus = async () => {
        this.setState({
            loadingFilterResourceStatus: true,
        })

        let resourceStatusValue = Array.isArray(this.state.filterInstituteIID)
            ? this.state.filterInstituteIID
            : [this.state.filterInstituteIID];

        let requestData = {
            "iid": config.institute_id,
            "iidArray": resourceStatusValue
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryResourceStatus',
            requestData,
            "/api/library/libraryResourceStatus.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterLibraryResourceStatus();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    filterResourceStatusData: apiResult.data,
                    loadingFilterResourceStatus: false,
                })
            } else {
                this.setState({
                    loadingFilterResourceStatus: false,
                })
            }
        }
    }

    //FILTER API CALL TO GET get invoice List 
    apiFilterLibraryInvoiceListDataStatus = async () => {
        this.setState({
            loadingFilterInvoice: true,
        })

        let requestData = {
            iid: config.institute_id,
            pageIndex: "all",
            limitPerPage: "all",
            linkedTo: "library"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getTransactionListBasedOnLinkedTo',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterLibraryInvoiceListDataStatus();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    billno: seriesData?.billno, // Display billno
                    vendorName: seriesData?.vendorName,
                    billdate: seriesData?.billdate,
                    vendorId: seriesData?.vendor,
                    uniqueId: seriesId
                }));

                this.setState({
                    filterInvoiceData: formattedData,
                    loadingFilterInvoice: false,
                })
            } else {
                this.setState({
                    loadingFilterInvoice: false,
                })
            }
        }
    }

    //FILTER API CALL TO GET DONOR'S LIST
    apiFilterGetDonorsList = async () => {
        this.setState({
            loadingFilterDonor: true,
        })

        let requestData = {
            institute_id: config.institute_id,
            // page_index: 1,
            // limit: 10,
            filter_name: "",
            filter_contact: "",
            filter_email: ""
            // Initially show 10 if any search word given then remove page index and limit
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "library_getDonorList",
            requestData,
            "/api/library/library.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterGetDonorsList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.data) {
                    const formattedMembers = Object.values(jsonResponse.APIResult.data)?.map((donorData) => {
                        // Start with the donorName
                        let label = donorData?.donorName || '';

                        // Conditionally add contact, address, and email if they are not empty
                        if (donorData?.donorContact) {
                            label += ` | ${donorData.donorContact}`;
                        }
                        if (donorData?.donorAddress) {
                            label += ` | ${donorData.donorAddress}`;
                        }
                        if (donorData?.donorEmail) {
                            label += ` | ${donorData.donorEmail}`;
                        }

                        return {
                            value: donorData.uniqueId,
                            label: label,
                            name: donorData?.donorName
                        };
                    });
                    this.setState({ filterDonorData: formattedMembers, loadingFilterDonor: false });

                } else {
                    this.setState({
                        filterDonorData: [],
                        loadingFilterDonor: false
                    });
                }
            }
        }
    };

    /** -------- **/

    // basic resource list
    GetLibraryResourceBasicDetailsList = async () => {
        this.setState({
            resourceListLoading: true
        });

        let requestData = {
            iid: this.state.resourceSearchIID,
            pageIndex: this.state.pageIndex,
            limitPerPage: this.state.limit,
            type: "All",
            // iidArray: this.props.iidArray.iidArray
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "GetLibraryResourceBasicDetailsList",
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceBasicDetailsList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                this.setState({
                    resourceDetailsList: apiResult.data,
                    sortedIdArray: apiResult.sortedIdArray,
                    totalResourcesItems: apiResult?.resource_count,
                    resourceListLoading: false
                });
            }
        }
    };

    // filtered list
    GetFilteredLibraryResourceList = async () => {
        this.setState({
            resourceListLoading: true
        });

        let accessionSeriesIdArray = [];
        let departmentIdArray = [];
        let categoryIdArray = [];
        let locationIdArray = [];
        let typeNameArray = [];
        let statusNameArray = [];
        let multipleAccessionNo = [];

        this.state.resourceSearchAccessionSeries?.map((item) => {
            accessionSeriesIdArray.push(item.value)
        })

        this.state.departmentAdvanceFilterValue?.map((item) => {
            departmentIdArray.push(item.value)
        })

        this.state.categoryAdvanceFilterValue?.map((item) => {
            categoryIdArray.push(item.value)
        })

        this.state.locationAdvanceFilterValue?.map((item) => {
            locationIdArray.push(item.value)
        })

        this.state.typeAdvanceFilterValue?.map((item) => {
            typeNameArray.push(item.value)
        })

        this.state.statusAdvanceFilterValue?.map((item) => {
            statusNameArray.push(item.value)
        })

        this.state.searchMultipleAccessionNumber?.map((item) => {
            multipleAccessionNo.push(item.value)
        })

        let searchTitleValue = this.state.resourceSearchTitle ? btoa(encodeURIComponent(this.state.resourceSearchTitle.trim())) : "";
        let searchAuthorValue = this.state.resourceSearchAuthor ? btoa(encodeURIComponent(this.state.resourceSearchAuthor.trim())) : "";
        let searchAccessionNumberValue = this.state.resourceSearchAccessionNumber ? this.state.resourceSearchAccessionNumber.trim() : "";
        let searchAccessionSeriesValue = accessionSeriesIdArray;
        let searchDepartmentValue = departmentIdArray;
        let searchCategoryValue = categoryIdArray;
        let searchLocationValue = locationIdArray;
        let searchTypeValue = typeNameArray;
        let searchStatusValue = statusNameArray;
        let donationStatusValue = this.state.isDonated == true ? "donated" : "notDonated";
        let searchMultipleAccessionNumberValue = multipleAccessionNo;

        let filterParameter = {
            "searchTitle": searchTitleValue,
            "searchAuthor": searchAuthorValue,
            "searchAccessionNumber": searchAccessionNumberValue,
            "searchinvoice": "",
            "resource_status": searchStatusValue,
            "searchseries": searchAccessionSeriesValue,
            "streams": searchDepartmentValue,
            "searchresourcecategory": searchCategoryValue,
            "searchlocation": searchLocationValue,
            "searchType": searchTypeValue,
            "resource_donation_status": donationStatusValue,
            "searchMultipleAccessionNumber": searchMultipleAccessionNumberValue,
            "searchAccessionNumberFrom": this.state.searchAccessionNumberFrom,
            "searchAccessionNumberTo": this.state.searchAccessionNumberTo,
            "filteredIID": this.state.resourceSearchIID
        }

        let requestData = {
            iid: config.institute_id,
            pageIndex: this.state.pageIndex,
            limitPerPage: this.state.limit,
            filterParameter: filterParameter,
            iidArray: this.props.iidArray.iidArray
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "GetFilteredLibraryResourceList",
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetFilteredLibraryResourceList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                this.setState({
                    resourceDetailsList: apiResult.data,
                    sortedIdArray: apiResult.sortedIdArray,
                    totalResourcesItems: apiResult?.resource_count,
                    resourceListLoading: false
                });
            }
        }
    };

    // API CALL TO GET get Institute Stream List 
    apiCallToGetInstituteStreamList = async () => {
        this.setState({
            loadingStreamData: true,
        })

        let addResourceIID = '';
        if (this.state.addResourceInstituteIID.length > 0) {
            addResourceIID = this.state.addResourceInstituteIID[0].value
        } else {
            addResourceIID = this.state.addResourceInstituteIID.value
        }

        let requestData = {
            "iid": this.state.typeOfIIDScreen == 'Add' ? addResourceIID : this.state.resourceSearchIID
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getInstituteStreamList',
            requestData,
            "/api/instructor/facultyRegistration.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetStreamList: apiResult.streamData,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    apiCallToGetAccessionSeries = async () => {
        this.setState({ isFilterLoading: true });

        let addResourceIID = '';
        if (this.state.addResourceInstituteIID.length > 0) {
            addResourceIID = this.state.addResourceInstituteIID[0].value
        } else {
            addResourceIID = this.state.addResourceInstituteIID.value
        }

        let requestData = {
            "iid": this.state.typeOfIIDScreen == 'Add' ? addResourceIID : this.state.resourceSearchIID
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                // if (Object.keys(apiResult).length > 0) {
                //     Object.keys(apiResult).map(seriesId => {
                //         apiResult[seriesId]['seriesId'] = seriesId;
                //     });
                // }

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    isFilterLoading: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    isFilterLoading: false
                });
            }
        }
    }

    // API CALL TO GET get location List 
    GetLibraryLocationList = async () => {
        this.setState({
            loadingLocationData: true,
        })

        let addResourceIID = '';
        if (this.state.addResourceInstituteIID.length > 0) {
            addResourceIID = this.state.addResourceInstituteIID[0].value
        } else {
            addResourceIID = this.state.addResourceInstituteIID.value
        }


        let requestData = {
            iid: this.state.typeOfIIDScreen == 'Add' ? addResourceIID : this.state.resourceSearchIID
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryLocationList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryLocationList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const sublocations = [];

                    // If there are sublocations, iterate through them
                    if (seriesData.subLocationCount > 0) {
                        Object.entries(seriesData.sublocation).forEach(([sublocationId, sublocationData]) => {
                            sublocations.push({
                                sublocationId: sublocationId,
                                sublocationName: sublocationData.name
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        sublocations: sublocations // Add sublocation data (if any)
                    };
                });

                this.setState({
                    GetLocationList: formattedData,
                    loadingLocationData: false,
                })
            } else {
                this.setState({
                    loadingLocationData: false,
                })
            }
        }
    }

    // API CALL TO GET get resource category List 
    GetLibraryResourceCategoryListWithBasicDetails = async () => {
        this.setState({
            loadingResourceCategoryData: true,
        })

        let addResourceIID = '';
        if (this.state.addResourceInstituteIID.length > 0) {
            addResourceIID = this.state.addResourceInstituteIID[0].value
        } else {
            addResourceIID = this.state.addResourceInstituteIID.value
        }

        let requestData = {
            iid: this.state.typeOfIIDScreen == 'Add' ? addResourceIID : this.state.resourceSearchIID,
            isSortByAscendingCategoryName: "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceCategoryListWithBasicDetails',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceCategoryListWithBasicDetails();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const subCategories = [];

                    // If there are subCategories, iterate through them
                    if (Object.values(seriesData.subresource).length > 0) {
                        Object.entries(seriesData.subresource).forEach(([subCategoryId, subCategoryData]) => {
                            subCategories.push({
                                subCategoryId: subCategoryId,
                                subCategoryName: subCategoryData.name,
                                parentId: subCategoryData.parentCategoryId
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        subCategories: subCategories // Add subresource data (if any)
                    };
                });


                this.setState({
                    GetResourceCategoryList: formattedData,
                    loadingResourceCategoryData: false,
                })
            } else {
                this.setState({
                    loadingResourceCategoryData: false,
                })
            }
        }
    }

    // API CALL TO GET get publisher List 
    getPublisherList = async () => {
        this.setState({
            loadingPublisherData: true,
        })

        let addResourceIID = '';
        if (this.state.addResourceInstituteIID.length > 0) {
            addResourceIID = this.state.addResourceInstituteIID[0].value
        } else {
            addResourceIID = this.state.addResourceInstituteIID.value
        }

        let requestData = {
            iid: this.state.typeOfIIDScreen == 'Add' ? addResourceIID : this.state.resourceSearchIID,
            isOrderByAscendingDisplayName: "true",
            pageIndex: "all",
            limitPerPage: "all"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPublisherList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPublisherList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    name: seriesData?.name,
                }));

                this.setState({
                    GetPublisherList: formattedData,
                    loadingPublisherData: false,
                })
            } else {
                this.setState({
                    loadingPublisherData: false,
                })
            }
        }
    }

    // API CALL TO GET get resource status List 
    getLibraryResourceStatus = async () => {
        this.setState({
            loadingResourceStatusData: true,
        })
        let requestData = {
            "iid": this.state.resourceSearchIID
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryResourceStatus',
            requestData,
            "/api/library/libraryResourceStatus.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getLibraryResourceStatus();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetResourceStatusList: apiResult.data,
                    loadingResourceStatusData: false,
                })
            } else {
                this.setState({
                    loadingResourceStatusData: false,
                })
            }
        }
    }

    // API CALL TO GET get invoice List 
    getLibraryInvoiceListDataStatus = async () => {
        this.setState({
            loadingInvoiceData: true,
        })

        let addResourceIID = '';
        if (this.state.addResourceInstituteIID.length > 0) {
            addResourceIID = this.state.addResourceInstituteIID[0].value
        } else {
            addResourceIID = this.state.addResourceInstituteIID.value
        }

        let requestData = {
            iid: this.state.typeOfIIDScreen == 'Add' ? addResourceIID : this.state.resourceSearchIID,
            pageIndex: "all",
            limitPerPage: "all",
            linkedTo: "library"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getTransactionListBasedOnLinkedTo',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getLibraryInvoiceListDataStatus();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    billno: seriesData?.billno, // Display billno
                    vendorName: seriesData?.vendorName,
                    billdate: seriesData?.billdate,
                    vendorId: seriesData?.vendor,
                    uniqueId: seriesId,
                    note: seriesData?.note,
                }));

                this.setState({
                    GetInvoiceDataList: formattedData,
                    loadingInvoiceData: false,
                })
            } else {
                this.setState({
                    loadingInvoiceData: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET MULTIPLE ACCESSION NUMBER
    getMultipleAccessionNoList = async () => {
        this.setState({ loadingAccessionNumberData: true });

        let accessionSeriesIdArray = []
        this.state.resourceSearchAccessionSeries?.map((item) => {
            accessionSeriesIdArray.push(item.value)
        })


        let requestData = {
            "iid": config.institute_id,
            "accessionSeriesIdArr": accessionSeriesIdArray,
            "searchAccssionSeriesNo": this.state.searchAccessionNo,
            "pageIndex": 1,
            "limitPerPage": 10
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getMultipleAccessionNumber',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getMultipleAccessionNoList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                const formattedMembers = Object.values(apiResult)?.map((data) => ({
                    value: data.resourceId,
                    label: data?.accessionNo,
                }));

                this.setState({
                    GetMultipleAccessionNumberList: formattedMembers,
                    loadingAccessionNumberData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession number list. Please try again later.',
                    loadingAccessionNumberData: false
                });
            }
        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // single checkbox check 
    handleCheckboxChange = (id) => {
        this.setState((prevState) => {
            const selectedRows = prevState.selectedRows.includes(id)
                ? prevState.selectedRows.filter((rowId) => rowId !== id) // Remove if already selected
                : [...prevState.selectedRows, id]; // Add if not selected

            return { selectedRows };
        });

    };

    // multiple checkbox check 
    handleSelectAllCheckboxChange = () => {
        this.setState((prevState) => {
            const allRowsSelected = prevState.selectedRows.length === Object.values(this.state.resourceDetailsList).length;

            return {
                selectedRows: allRowsSelected ? [] : Object.values(this.state.resourceDetailsList).map((project) => project.uniqueId),
            };
        });
    };

    // on change for show entries per page
    resetResourcePerPageList = (event) => {
        let filterIidValue = "";
        if (this.state.filterInstituteIID.length > 1) {
            filterIidValue = ""
        } else {
            filterIidValue = this.state.filterInstituteIID[0]
        }

        if (this.state.resourceSearchTitle !== '' || this.state.resourceSearchAuthor !== '' || this.state.resourceSearchIID !== String(config.institute_id) || this.state.resourceSearchAccessionSeries?.length > 0 || this.state.resourceSearchAccessionNumber !== "" || this.state.searchAccessionNumberFrom !== '' || this.state.searchAccessionNumberTo !== '' || this.state.searchMultipleAccessionNumber?.length > 0 || this.state.departmentAdvanceFilterValue?.length > 0 || this.categoryAdvanceFilterValue?.length > 0 || this.state.locationAdvanceFilterValue?.length > 0 || this.state.typeAdvanceFilterValue?.length > 0 || this.state.statusAdvanceFilterValue?.length > 0 || this.state.isDonated !== false) {
            this.setState({
                selectedRows: [], pageIndex: 1, limit: event.target.value, resourceSearchTitle: this.state.resourceSearchTitle, resourceSearchAuthor: this.state.resourceSearchAuthor, resourceSearchIID: this.state.filterInstituteIID?.length > 0 ? filterIidValue : this.state.resourceSearchIID,
                resourceSearchAccessionSeries: this.state.resourceSearchAccessionSeries, resourceSearchAccessionNumber: this.state.resourceSearchAccessionNumber, searchMultipleAccessionNumber: this.state.searchMultipleAccessionNumber, searchAccessionNumberFrom: this.state.searchAccessionNumberFrom,
                searchAccessionNumberTo: this.state.searchAccessionNumberTo, departmentAdvanceFilterValue: this.state.departmentAdvanceFilterValue, categoryAdvanceFilterValue: this.state.categoryAdvanceFilterValue, locationAdvanceFilterValue: this.state.locationAdvanceFilterValue, typeAdvanceFilterValue: this.state.typeAdvanceFilterValue,
                statusAdvanceFilterValue: this.state.statusAdvanceFilterValue, isDonated: this.state.isDonated
            }, () => {
                this.GetFilteredLibraryResourceList();
            });
        } else {
            this.setState({ selectedRows: [], pageIndex: 1, limit: event.target.value }, () => {
                this.GetLibraryResourceBasicDetailsList();
            });
        }
    }

    // on change for per page change
    handleResourcePageChange = (pageNumber) => {
        let filterIidValue = "";
        if (this.state.filterInstituteIID.length > 1) {
            filterIidValue = ""
        } else {
            filterIidValue = this.state.filterInstituteIID[0]
        }

        if (this.state.resourceSearchTitle !== '' || this.state.resourceSearchAuthor !== '' || this.state.resourceSearchIID !== String(config.institute_id) || this.state.resourceSearchAccessionSeries?.length > 0 || this.state.resourceSearchAccessionNumber !== "" || this.state.searchAccessionNumberFrom !== '' || this.state.searchAccessionNumberTo !== '' || this.state.searchMultipleAccessionNumber?.length > 0 || this.state.departmentAdvanceFilterValue?.length > 0 || this.categoryAdvanceFilterValue?.length > 0 || this.state.locationAdvanceFilterValue?.length > 0 || this.state.typeAdvanceFilterValue?.length > 0 || this.state.statusAdvanceFilterValue?.length > 0 || this.state.isDonated !== false) {
            this.setState({
                selectedRows: [], pageIndex: pageNumber, resourceSearchTitle: this.state.resourceSearchTitle, resourceSearchAuthor: this.state.resourceSearchAuthor, resourceSearchIID: this.state.filterInstituteIID?.length > 0 ? filterIidValue : this.state.resourceSearchIID,
                resourceSearchAccessionSeries: this.state.resourceSearchAccessionSeries, resourceSearchAccessionNumber: this.state.resourceSearchAccessionNumber, searchMultipleAccessionNumber: this.state.searchMultipleAccessionNumber, searchAccessionNumberFrom: this.state.searchAccessionNumberFrom,
                searchAccessionNumberTo: this.state.searchAccessionNumberTo, departmentAdvanceFilterValue: this.state.departmentAdvanceFilterValue, categoryAdvanceFilterValue: this.state.categoryAdvanceFilterValue, locationAdvanceFilterValue: this.state.locationAdvanceFilterValue, typeAdvanceFilterValue: this.state.typeAdvanceFilterValue,
                statusAdvanceFilterValue: this.state.statusAdvanceFilterValue, isDonated: this.state.isDonated
            }, () => {
                this.GetFilteredLibraryResourceList();
            });
        } else {
            this.setState({ selectedRows: [], pageIndex: pageNumber }, () => {
                this.GetLibraryResourceBasicDetailsList();
            });
        }
    };

    // CLEAR ALL FILTER
    handleClearAllResourceFilter = () => {
        this.setState({
            resourceSearchAccessionSeries: [], resourceSearchAccessionNumber: '', resourceSearchIID: config.institute_id, resourceSearchTitle: '', resourceSearchAuthor: '', limit: "10", pageIndex: 1, departmentAdvanceFilterValue: [], categoryAdvanceFilterValue: [], locationAdvanceFilterValue: [],
            typeAdvanceFilterValue: [], statusAdvanceFilterValue: [], searchMultipleAccessionNumber: [], searchAccessionNumberFrom: '', searchAccessionNumberTo: '', filterInstituteIID: config.institute_id
        }, () => {
            this.GetLibraryResourceBasicDetailsList();
            this.apiCallToGetAccessionSeries();
        })
    };

    // resource filter title on change
    handleResourceTitleChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", resourceSearchTitle: event.target.value, selectedRows: [] });
    };
    handleResourceTitleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceList();
        }
    };

    // resource filter author on change
    handleResourceAuthorChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", resourceSearchAuthor: event.target.value, selectedRows: [] });
    };
    handleResourceAuthorKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceList();
        }
    };

    // resource filter accession no on change
    handleResourceAccessionNoChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", resourceSearchAccessionNumber: event.target.value, selectedRows: [] });
    };
    handleResourceAccessionNoKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceList();
        }
    };

    // // resource filter iid on change
    // handleResourceIIdChange = (event) => {
    //     this.setState({ pageIndex: 1, limit: "10", resourceSearchIID: event.target.value, resourceSearchAccessionSeries: [] }, () => {
    //         this.apiCallToGetAccessionSeries();
    //         this.GetFilteredLibraryResourceList();
    //     });
    // };

    // resource filter accession series on change
    handleResourceAccessionSeriesChange = (event) => {
        this.setState({
            pageIndex: 1, limit: "10",
            resourceSearchAccessionSeries: event || [], // Handle empty selection
        }, () => {
            this.GetFilteredLibraryResourceList()
            this.getMultipleAccessionNoList()
        }
        )
    };

    // filter Accession Number from on change
    handleFilterAccessionNoFromChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchAccessionNumberFrom: event.target.value });
    };

    // filter Accession Number to on change
    handleFilterAccessionNoToChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchAccessionNumberTo: event.target.value });
    };

    // selected resources details data
    GetLibraryMultipleResourcesDetails = async () => {
        this.setState({
            loadingMultipleResourcesData: true,
            openBulkUpdateResourceModal: false
        });

        let requestData = {
            iid: this.state.resourceSearchIID,
            uniqueid: this.state.selectedRows
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "GetLibraryMultipleResourceDetails",
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryMultipleResourcesDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            multipleResourcesDetails: apiResult.data,
                            loadingMultipleResourcesData: false,
                            openBulkUpdateResourceModal: true
                        });
                    }
                    else {
                        this.setState({
                            multipleResourcesDetails: {},
                            openBulkUpdateResourceModal: false,
                        })
                    }
                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

                    this.setState({
                        multipleResourcesDetails: {},
                        openBulkUpdateResourceModal: false,

                    })
                }
            }
        }
    };

    // Advance Filter Model - Method to open modal
    advanceFilterModal = () => {
        this.setState({
            advanceFilterModal: true,
        })
    }

    closeAdvanceFilterModal = () => {
        this.setState({
            advanceFilterModal: false,
            resourceSearchTitle: '',
            resourceSearchAuthor: '',
            resourceSearchIID: config.institute_id,
            resourceSearchAccessionSeries: [],
            resourceSearchAccessionNumber: '',
            departmentAdvanceFilterValue: [],
            categoryAdvanceFilterValue: [],
            locationAdvanceFilterValue: [],
            typeAdvanceFilterValue: [],
            statusAdvanceFilterValue: [],
            isDonated: false,
            searchMultipleAccessionNumber: [],
            searchAccessionNumberFrom: '',
            searchAccessionNumberTo: '',
        })
    }

    // METHOD TO ADVANCE FILTER
    returnAdvanceFilterModelData = () => {
        return (
            <div className={this.state.advanceFilterModal ? "modal fade show" : "modal fade"} id="modalContainer">
                <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50VW' }}>
                    <div className="modal-content modalBulkContent">
                        {/* Modal Header */}
                        <div className="modal-header" style={{ padding: '20px 25px', borderBottom: '2px solid #e0e0e0' }}>
                            <h6 className="modal-title">
                                {/* <img src={advanceFilter} alt="Advanced Filter" style={{ marginRight: '10px' }} /> */}
                                <FontAwesomeIcon size='sm' icon={["fa", "filter"]} style={{ marginRight: '10px' }} />
                                Advanced Filter
                            </h6>
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => this.closeAdvanceFilterModal()} style={{ cursor: "pointer" }} />
                            {/* <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => { this.setState({ advanceFilterModal: false }) }}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button> */}
                        </div>

                        {/* Modal Content */}
                        <div className="custom-form-body" style={{ padding: '10px', overflowY: 'auto', maxHeight: '60vh' }}>


                            {/* Form Group: Accession Series &  Multiple Accession Number */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="SeriesAdvFilter">
                                        Accession Series
                                    </label>
                                    <Select
                                        isMulti
                                        name="SeriesAdvFilter"
                                        options={Object.values(this.state.filterAccessionSeriesData)}
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1, limit: "10",
                                                resourceSearchAccessionSeries: event || [], // Handle empty selection
                                                searchMultipleAccessionNumber: [], searchAccessionNumberFrom: '', searchAccessionNumberTo: ''
                                            }, () => {
                                                if (this.state.resourceSearchAccessionSeries?.length > 0) {
                                                    this.getMultipleAccessionNoList();
                                                }
                                            })
                                        }}
                                        value={this.state.resourceSearchAccessionSeries}
                                        placeholder="Select Accession Series"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="SeriesAdvFilter">
                                        Multiple Accession Number
                                    </label>
                                    <Select
                                        isMulti
                                        name="SeriesAdvFilter"
                                        options={this.state.GetMultipleAccessionNumberList}
                                        onChange={(event) => {
                                            this.setState({
                                                searchMultipleAccessionNumber: event || [], // Handle empty selection
                                            })
                                        }}
                                        onInputChange={(inputValue) => {
                                            this.setState({ searchAccessionNo: inputValue }, () => {
                                                if (this.state.resourceSearchAccessionSeries?.length > 0) {
                                                    this.getMultipleAccessionNoList(); // Trigger the API call after updating the search term
                                                }
                                            }, 200);
                                        }}
                                        isDisabled={!this.state.resourceSearchAccessionSeries || this.state.resourceSearchAccessionSeries.length === 0} // Disable if searchByAccessionSeries is empty
                                        value={this.state.searchMultipleAccessionNumber}
                                        placeholder="Select Accession Number"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexDirection: 'column', // Make selected options stack vertically
                                                marginBottom: '5px', // Adjust space between selected options
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                padding: '5px 10px', // Add padding to the labels for better readability
                                                whiteSpace: 'normal', // Allow text wrapping if needed
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                display: 'none', // Optionally hide the remove button if you don't need it
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>

                            {/* Form Group: accession number from and accession number to */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body3" color='#454E52'>Accession Number From</label>
                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                        <img
                                            src={searchPng}
                                            style={{
                                                position: 'absolute',
                                                left: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#ccc',
                                                backgroundColor: 'white',
                                                width: '15px',
                                                height: '15px',
                                                zIndex: 1,
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control formControlAutoTask"
                                            id="searchByAccessionNoFromFilter"
                                            placeholder="Search by Accession Number From"
                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                            value={this.state.searchAccessionNumberFrom} // Bind value to state
                                            onChange={this.handleFilterAccessionNoFromChange} // Handle input changes
                                            disabled={!this.state.resourceSearchAccessionSeries || this.state.resourceSearchAccessionSeries.length === 0} // Disable when empty or falsy
                                        />
                                    </div>
                                    <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>Select accession series to enter accession no from data.</p>
                                </div>
                                <div className="col-md-6">
                                    <label className="vm_custom_body3" color='#454E52'>Accession Number To</label>
                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                        <img
                                            src={searchPng}
                                            style={{
                                                position: 'absolute',
                                                left: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#ccc',
                                                backgroundColor: 'white',
                                                width: '15px',
                                                height: '15px',
                                                zIndex: 1,
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control formControlAutoTask"
                                            id="searchByAccessionNoToFilter"
                                            placeholder="Search by Accession Number To"
                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                            value={this.state.searchAccessionNumberTo} // Bind value to state
                                            onChange={this.handleFilterAccessionNoToChange} // Handle input changes
                                            disabled={!this.state.resourceSearchAccessionSeries || this.state.resourceSearchAccessionSeries.length === 0} // Disable when empty or falsy
                                        />
                                    </div>
                                    <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>Select accession series to enter accession no to data.</p>
                                </div>
                            </div>


                            {/* Form Group: Accession Number and Department */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="AccessionNumberAdvFilter">
                                        Accession Number
                                    </label>
                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                        <img
                                            src={searchPng}
                                            style={{
                                                position: 'absolute',
                                                left: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#ccc',
                                                backgroundColor: 'white',
                                                width: '18px',
                                                height: '18px',
                                                zIndex: 1,
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="AccessionNumberAdvFilter"
                                            placeholder="Search by Accession Number"
                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: 'auto' }}
                                            value={this.state.resourceSearchAccessionNumber}
                                            onChange={(event) => {
                                                this.setState({
                                                    pageIndex: 1, limit: "10",
                                                    resourceSearchAccessionNumber: event.target.value
                                                })
                                            }}
                                        />
                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="resourceDepartmentFilter">
                                        Department
                                    </label>
                                    <Select
                                        isMulti
                                        name="resourceDepartmentFilter"
                                        options={Object.entries(this.state.filterDepartmentData).map(([key, item]) => ({
                                            value: key,  // set the key (like "267") as the value
                                            label: (item?.instituteShortCode) ? `${item.stream_name} | ${item.instituteShortCode}` : `${item.stream_name}`
                                        }))}
                                        value={this.state.departmentAdvanceFilterValue}
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1, limit: "10",
                                                departmentAdvanceFilterValue: event || [], // Handle empty selection
                                            })
                                        }}
                                        placeholder="Select Department"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexDirection: 'column', // Make selected options stack vertically
                                                marginBottom: '5px', // Adjust space between selected options
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                padding: '5px 10px', // Add padding to the labels for better readability
                                                whiteSpace: 'normal', // Allow text wrapping if needed
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                display: 'none', // Optionally hide the remove button if you don't need it
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>

                            {/* Form Group: Category and Location */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="resourceCategoryFilter">
                                        Resource Category
                                    </label>
                                    <Select
                                        isMulti
                                        name="resourceCategoryFilter"
                                        options={Object.values(this.state.filterResourceCategoryData).flatMap(item => {
                                            // Start with the category itself
                                            const categoryOption = {
                                                value: item.value,
                                                label: item.name,
                                                isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                                            };

                                            // If the category has subcategories, add those as well
                                            const subCategoryOptions = item.subCategories.map(subCategory => ({
                                                value: subCategory.subCategoryId,
                                                label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                                                isDisabled: false, // Subcategory is always enabled
                                            }));

                                            // Return the category option followed by the subcategory options
                                            return [categoryOption, ...subCategoryOptions];
                                        })}
                                        value={this.state.categoryAdvanceFilterValue}
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1, limit: "10",
                                                categoryAdvanceFilterValue: event || [], // Handle empty selection
                                            })
                                        }}
                                        placeholder="Select Category"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexDirection: 'column', // Make selected options stack vertically
                                                marginBottom: '5px', // Adjust space between selected options
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                padding: '5px 10px', // Add padding to the labels for better readability
                                                whiteSpace: 'normal', // Allow text wrapping if needed
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                display: 'none', // Optionally hide the remove button if you don't need it
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="resourceLocationFilter">
                                        Location
                                    </label>
                                    <Select
                                        isMulti
                                        name="resourceLocationFilter"
                                        options={Object.values(this.state.filterLocationData)?.flatMap((data) => {
                                            // Start with the parent location itself
                                            const locationOption = {
                                                value: data.value,
                                                label: data.name,
                                                isDisabled: data.sublocations && data.sublocations.length > 0, // Disable the parent if it has sublocations
                                            };

                                            // If the location has sublocations, add them as well
                                            const subLocationOptions = data.sublocations?.map((sublocation) => ({
                                                value: sublocation.sublocationId,
                                                label: `${data.name} => ${sublocation.sublocationName}`, // Parent location followed by sublocation name
                                                isDisabled: false, // Subcategory is always enabled
                                            }));

                                            // Return the location option followed by the sublocation options
                                            return [locationOption, ...subLocationOptions];
                                        })}
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1, limit: "10",
                                                locationAdvanceFilterValue: event || [], // Handle empty selection
                                            })
                                        }}
                                        value={this.state.locationAdvanceFilterValue}
                                        placeholder="Select Location"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexDirection: 'column', // Make selected options stack vertically
                                                marginBottom: '5px', // Adjust space between selected options
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                padding: '5px 10px', // Add padding to the labels for better readability
                                                whiteSpace: 'normal', // Allow text wrapping if needed
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                display: 'none', // Optionally hide the remove button if you don't need it
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>

                            {/* Form Group: Resource Type and Resource Status */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="resourceTypeFilter">
                                        Resource Type
                                    </label>
                                    <Select
                                        isMulti
                                        name="resourceTypeFilter"
                                        options={resourceTypeData.map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                        value={this.state.typeAdvanceFilterValue}
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1, limit: "10",
                                                typeAdvanceFilterValue: event || [], // Handle empty selection
                                            })
                                        }}
                                        placeholder="Select Resource Type"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexDirection: 'column', // Make selected options stack vertically
                                                marginBottom: '5px', // Adjust space between selected options
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                padding: '5px 10px', // Add padding to the labels for better readability
                                                whiteSpace: 'normal', // Allow text wrapping if needed
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                display: 'none', // Optionally hide the remove button if you don't need it
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="resourceStatusFilter">
                                        Resource Status
                                    </label>
                                    <Select
                                        isMulti
                                        name="resourceStatusFilter"
                                        options={Object.values(this.state.filterResourceStatusData).map(item => ({
                                            value: item.status,
                                            label: item.status,
                                        }))}
                                        value={this.state.statusAdvanceFilterValue}
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1, limit: "10",
                                                statusAdvanceFilterValue: event || [], // Handle empty selection
                                            })
                                        }}
                                        placeholder="Select Status"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexDirection: 'column', // Make selected options stack vertically
                                                marginBottom: '5px', // Adjust space between selected options
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                padding: '5px 10px', // Add padding to the labels for better readability
                                                whiteSpace: 'normal', // Allow text wrapping if needed
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                display: 'none', // Optionally hide the remove button if you don't need it
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>

                            {/* Form Group: Only Donated Resources */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52'>
                                        <input
                                            type="checkbox"
                                            checked={this.state.isDonated}
                                            onChange={() => {
                                                // Toggle the value of isDonated
                                                this.setState(prevState => ({
                                                    pageIndex: 1,  // Resetting pageIndex to 1
                                                    limit: "10",    // Resetting limit to 10
                                                    isDonated: !prevState.isDonated // Toggle the isDonated state
                                                }))
                                            }}
                                            style={{ marginRight: '10px' }}  // Adding space between the checkbox and text
                                        />
                                        Only Donated Resources
                                    </label>
                                </div>

                            </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer" style={{ padding: '20px 25px' }}>
                            <button
                                className="btn custom-btn"
                                style={{ fontSize: '14px', borderRadius: '7px' }}
                                // borderColor: '#0465AC !important'
                                onClick={() => {
                                    this.closeAdvanceFilterModal();
                                    this.setState({
                                        resourceSearchIID: config.institute_id, isDonated: false
                                    }, () => {
                                        this.GetLibraryResourceBasicDetailsList();
                                        this.apiCallToGetAccessionSeries(); // accession series
                                        this.GetLibraryLocationList();  // location list
                                        this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
                                        this.getLibraryResourceStatus();  // resource status
                                        this.getLibraryInvoiceListDataStatus();  // invoice data
                                        this.apiCallToGetInstituteStreamList(); // stream (department)
                                    })
                                }}
                            >
                                Clear
                            </button>
                            <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => {
                                this.GetFilteredLibraryResourceList();
                                this.setState({ advanceFilterModal: false })
                            }}>
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Update Donor Model - Method to open modal
    updateDonorModalOpen = () => {
        const hasDifferentIID = new Set(selectedCheckboxIID).size > 1;

        if (hasDifferentIID) {
            this.setState({ selectedRows: [] })
            toast.warn("Please select resources from the same Institute to perform this action.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            this.setState({
                updateDonorModal: true,
                resourceSearchIID: selectedCheckboxIID[0]
            }, () => { this.apiCallToGetDonorsList() }) // donor's list
        }

    }

    closeUpdateDonorModal = () => {
        this.setState({
            updateDonorModal: false,
            selectedDonorName: [],
            selectedRows: []
        })
    }

    // API CALL TO GET DONOR'S LIST
    apiCallToGetDonorsList = async () => {

        let addResourceIID = '';
        if (this.state.addResourceInstituteIID.length > 0) {
            addResourceIID = this.state.addResourceInstituteIID[0].value
        } else {
            addResourceIID = this.state.addResourceInstituteIID.value
        }

        this.setState({ loadingDonorsData: true });
        let requestData = {
            institute_id: this.state.typeOfIIDScreen == 'Add' ? addResourceIID : this.state.resourceSearchIID,
            page_index: 1,
            limit: 10,
            filter_name: this.state.searchByDonorName,
            filter_contact: "",
            filter_email: ""
            // Initially show 10 if any search word given then remove page index and limit
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "library_getDonorList",
            requestData,
            "/api/library/library.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetDonorsList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.data) {
                    const formattedMembers = Object.values(jsonResponse.APIResult.data)?.map((donorData) => {
                        // Start with the donorName
                        let label = donorData?.donorName || '';

                        // Conditionally add contact, address, and email if they are not empty
                        if (donorData?.donorContact) {
                            label += ` | ${donorData.donorContact}`;
                        }
                        if (donorData?.donorAddress) {
                            label += ` | ${donorData.donorAddress}`;
                        }
                        if (donorData?.donorEmail) {
                            label += ` | ${donorData.donorEmail}`;
                        }

                        return {
                            value: donorData.uniqueId,
                            label: label,
                            name: donorData?.donorName
                        };
                    });
                    this.setState({ donorsListData: formattedMembers, loadingDonorsData: false });

                } else {
                    this.setState({
                        donorsListData: [],
                        loadingDonorsData: false
                    });

                }
            } else {
                this.setState({ loadingDonorsData: false });
            }
        }
    };

    // API CALL TO GET DONOR'S LIST
    apiCallToGetAllDonorsList = async () => {
        let requestData = {
            institute_id: this.state.resourceSearchIID, //config.institute_id,
            // page_index: 1,
            // limit: 10,
            filter_name: "",
            filter_contact: "",
            filter_email: ""
            // Initially show 10 if any search word given then remove page index and limit
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "library_getDonorList",
            requestData,
            "/api/library/library.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAllDonorsList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.data) {
                    const formattedMembers = Object.values(jsonResponse.APIResult.data)?.map((donorData) => {
                        // Start with the donorName
                        let label = donorData?.donorName || '';

                        // Conditionally add contact, address, and email if they are not empty
                        if (donorData?.donorContact) {
                            label += ` | ${donorData.donorContact}`;
                        }
                        if (donorData?.donorAddress) {
                            label += ` | ${donorData.donorAddress}`;
                        }
                        if (donorData?.donorEmail) {
                            label += ` | ${donorData.donorEmail}`;
                        }

                        return {
                            value: donorData.uniqueId,
                            label: label,
                            name: donorData?.donorName
                        };
                    });
                    this.setState({ allDonorData: formattedMembers });

                } else {
                    this.setState({
                        allDonorData: [],

                    });
                }
            }
        }
    };

    // API CALL TO UPDATE DONOR TO SELECTED RESOURCES
    apiCallToUpdateResourceDonor = async (status) => {
        let selectedDonorId = this.state.selectedDonorName && this.state.selectedDonorName.value;
        let donorValue = status == "donated" ? selectedDonorId.toString() : ""
        let resourceObject = {
            fieldsObj: {
                value: donorValue,
                fieldName: status
            },
            selectedIdArray: this.state.selectedRows.map(id => id.toString())
        };
        let requestData = {
            iid: config.institute_id,
            resourceObject: resourceObject,
            facultyId: config.faculty_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "updateLibraryResourceSelectedFiledofSelectedResource",
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateResourceDonor()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    // this.setState({
                    //     selectedRows: []
                    // });
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    // this.apiCallToUpdateResourceDonor();
                } else {
                    // this.setState({
                    //     selectedRows: []
                    // });
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while updating donor. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }

    }

    // METHOD TO UPDATE DONORS
    returnUpdateDonors = () => {
        return (
            <div className={this.state.updateDonorModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50VW' }}>
                    <div class="modal-content">
                        {/* modal header data */}
                        <div class="modal-header" style={{ padding: '15px' }}>
                            <h6 class="modal-title text-white" style={{ fontWeight: 500, color: "#000000" }}>Add/Update Donor</h6>
                            {/* <button type="button" class="close" data-dismiss="modal" aria-label="Close" style={{ fontWeight: '500 !important', color: "#000000 !important" }}>
                                <span aria-hidden="true" onClick={() => { this.closeUpdateDonorModal() }}>&times;</span>
                            </button> */}
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => this.closeUpdateDonorModal()} style={{ cursor: "pointer" }} />
                        </div>

                        {/* modal content */}
                        <div class="modal-body" style={{ maxHeight: "75vh", height: '75vh', overflowY: 'auto' }}>
                            <div className="noteContainer">
                                {/* <p className="noteText">Note: Upon updating or adding, the new donor will replace the current donor for the specified resources. If you wish to remove any existing donor, please click on the 'Remove Donor' button.</p> */}
                                <p className="noteText">Note: Upon updating or adding, the new donor will replace the current donor for the specified resources. If you wish
                                    to remove any existing donor, please click to
                                    <span className='dropdown' >
                                        <a style={{ color: "#F2415A", textDecoration: "underline" }} data-toggle="dropdown" > remove.</a>
                                        <div class="dropdown-menu deleteMenu" aria-labelledby="dropdownMenuButton" style={{ whiteSpace: 'nowrap', minWidth: '150px' }}>
                                            <p style={{ fontSize: 14, marginBottom: '10px' }}>Are you sure you want to remove donor?</p>
                                            <div className="level-buttons" style={{ display: 'flex', padding: '0', justifyContent: 'end' }}>
                                                {/* borderColor: '#0465AC !important' */}
                                                <button className="btn" style={{ color: '#fff', fontSize: '14px', borderRadius: '7px', backgroundColor: '#0465AC' }} onClick={() => this.apiCallToUpdateResourceDonor("not_donated")}>Yes</button>
                                                <button className="btn custom-btn" style={{ borderRadius: '7px' }}>No</button>
                                            </div>
                                        </div>
                                    </span>
                                </p>

                            </div>
                            {/* <div className="modal-footer">
                                <button
                                    className="btn custom-btn" style={{ fontSize: '14px', borderRadius: '7px', borderColor: '#0465AC !important' }}
                                    onClick={() => this.apiCallToUpdateResourceDonor("not_donated")}>Remove Donor</button>
                            </div> */}

                            <div className="form-group row">
                                <div className="col-md-12">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="SeriesAdvFilter">
                                        Donor Name
                                    </label>
                                    <Select
                                        // isMulti
                                        options={Object.values(this.state.donorsListData)}
                                        onChange={(event) => {
                                            this.setState({
                                                selectedDonorName: event || [], // Handle empty selection
                                            })
                                        }}
                                        onInputChange={(inputValue) => {
                                            this.setState({ searchByDonorName: inputValue }, () => {
                                                this.apiCallToGetDonorsList(); // Trigger the API call after updating the search term
                                            }, 200);
                                        }}
                                        isSearchable
                                        isLoading={this.state.loadingDonorsData} // Show loading spinner while fetching
                                        value={this.state.selectedDonorName}
                                        placeholder="Enter Donor Name"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                                // maxHeight: '200px', // Limit the height of the dropdown
                                                overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                position: 'absolute', // Fix the position to avoid getting cut off
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the menu is above other modal content
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '14px',
                                                fontWeight: '400', // Use fontWeight for normal text

                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingDonorsData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Modal footer button */}
                        <div className="modal-footer" style={{ padding: '20px 25px' }}>
                            {/* borderColor: '#0465AC !important' */}
                            <button className="btn custom-btn" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => { this.closeUpdateDonorModal() }}><span className='fs-13'>Cancel</span></button>
                            {
                                <button className="btn" style={{ fontSize: '14px', borderRadius: '7px', color: '#fff', backgroundColor: this.state.selectedDonorName.length == 0 ? '#616161' : '#0465AC', cursor: this.state.selectedDonorName.length == 0 ? 'not-allowed' : 'pointer' }} disabled={this.state.selectedDonorName.length == 0}
                                    onClick={() => this.apiCallToUpdateResourceDonor("donated")}
                                >Add/Update Donor</button>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Set Parent Resource Model - Method to open modal
    updateUpdateParentResourceModalOpen = () => {
        const hasDifferentIID = new Set(selectedCheckboxIID).size > 1;

        if (hasDifferentIID) {
            this.setState({ selectedRows: [] })
            toast.warn("Please select resources from the same Institute to perform this action.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            this.setState({
                updateParentResourceModal: true,
                resourceSearchIID: selectedCheckboxIID[0],
                getOnlyParentResource: true
            })
        }

    }

    closeUpdateParentResourceModal = () => {
        this.setState({
            updateParentResourceModal: false,
            selectedResourceName: [],
            selectedRows: [],
            getOnlyParentResource: false
        })
    }

    //API CALL METHOD TO GET TITLE and AUTHOR DATA
    library_getResourceAuthorDetails = async () => {
        this.setState({ loadingTitleAuthorData: true });

        let requestData = {
            "iidArray": [this.state.resourceSearchIID],
            "title": this.state.searchByTitle,
            "author": this.state.searchByAuthor,
            "searchField": this.state.searchByTitleAuthorName,
            "getOnlyParentResource": this.state.getOnlyParentResource,
            "pageIndex": 1,
            "pageLimit": 10
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getResourceAuthorDetails',
            requestData,
            '/api/instructor/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_getResourceAuthorDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let GetResourceTitleListData = [];
                let GetResourceAuthorListData = [];
                let GetResourceDetailsListData = [];


                // If resourceDetails exists and has values
                if (apiResult.resourceDetails && Object.keys(apiResult.resourceDetails).length > 0) {
                    GetResourceDetailsListData = Object.values(apiResult.resourceDetails).map(item => ({
                        value: item.uniqueId,   // unique ID for react-select
                        label: [
                            item.accession_series_name,
                            item.accessionNumber,
                            item.title,
                            item.author
                        ]
                            .filter(Boolean) // removes null/undefined/empty values
                            .join(" | ")     // join with pipe
                    }));
                }

                // If titleDetails exists and has values
                if (apiResult.titleDetails && apiResult.titleDetails.length > 0) {
                    GetResourceTitleListData = apiResult.titleDetails.map(title => ({
                        value: title,
                        label: title
                    }));
                }

                // If authorDetails exists and has values
                if (apiResult.authorDetails && apiResult.authorDetails.length > 0) {
                    GetResourceAuthorListData = apiResult.authorDetails.map(author => ({
                        value: author,
                        label: author
                    }));
                }

        
                this.setState({
                    GetResourceTitleList: Array.isArray(GetResourceTitleListData) ? GetResourceTitleListData : [],
                    GetResourceAuthorList: Array.isArray(GetResourceAuthorListData) ? GetResourceAuthorListData : [],
                    GetResourceDetailsList: Array.isArray(GetResourceDetailsListData) ? GetResourceDetailsListData : [],
                    loadingTitleAuthorData: false
                });

            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting resource author details. Please try again later.',
                    loadingTitleAuthorData: false
                });
            }
        }
    }

    // API CALL TO UPDATE DONOR TO SELECTED RESOURCES
    library_updateResourceParentId = async (status) => {
        let requestData = {
            iidArray: [this.state.resourceSearchIID],
            parentResourceId: this.state.selectedResourceName?.value,
            selectedResourceIdArray: this.state.selectedRows.map(id => id.toString()),
            facultyId: config.faculty_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "library_updateResourceParentId",
            requestData,
            "/api/instructor/library.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_updateResourceParentId()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    this.setState({
                        selectedRows: []
                    });
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.closeUpdateParentResourceModal()
                } else {
                    // this.setState({
                    //     selectedRows: []
                    // });
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while updating donor. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // METHOD TO Update Parent Resource
    returnUpdateParentResource = () => {
        return (
            <div className={this.state.updateParentResourceModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50VW' }}>
                    <div class="modal-content">
                        {/* modal header data */}
                        <div class="modal-header" style={{ padding: '15px' }}>
                            <h6 class="modal-title text-white" style={{ fontWeight: 500, color: "#000000" }}>Update Parent Resource</h6>
                            {/* <button type="button" class="close" data-dismiss="modal" aria-label="Close" style={{ fontWeight: '500 !important', color: "#000000 !important" }}>
                                <span aria-hidden="true" onClick={() => { this.closeUpdateDonorModal() }}>&times;</span>
                            </button> */}
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => this.closeUpdateParentResourceModal()} style={{ cursor: "pointer" }} />
                        </div>

                        {/* modal content */}
                        <div class="modal-body" style={{ maxHeight: "75vh", height: '75vh', overflowY: 'auto' }}>
                            <div className="form-group row">
                                <div className="col-md-12">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="SeriesAdvFilter">
                                        Resource Details
                                    </label>
                                    <Select
                                        // isMulti
                                        options={this.state.GetResourceDetailsList}
                                        onChange={(event) => {
                                            this.setState({
                                                selectedResourceName: event || [], // Handle empty selection
                                            })
                                        }}
                                        onInputChange={(inputValue, { action }) => {
                                            if (action === "input-change") {
                                                this.setState({ searchByTitleAuthorName: inputValue }, () => {
                                                    this.library_getResourceAuthorDetails();
                                                });
                                            }
                                        }}
                                        isSearchable
                                        isLoading={this.state.loadingTitleAuthorData} // Show loading spinner while fetching
                                        value={this.state.selectedResourceName}
                                        placeholder="Search By Resource Title/Author Name"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                                // maxHeight: '200px', // Limit the height of the dropdown
                                                overflowY: 'auto', // Enable scrolling inside the dropdown if it exceeds maxHeight
                                                position: 'absolute', // Fix the position to avoid getting cut off
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the menu is above other modal content
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '14px',
                                                fontWeight: '400', // Use fontWeight for normal text

                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingTitleAuthorData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Modal footer button */}
                        <div className="modal-footer" style={{ padding: '20px 25px' }}>
                            {/* borderColor: '#0465AC !important' */}
                            <button className="btn custom-btn" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => { this.closeUpdateParentResourceModal() }}><span className='fs-13'>Cancel</span></button>
                            {
                                <button className="btn" style={{ fontSize: '14px', borderRadius: '7px', color: '#fff', backgroundColor: this.state.selectedResourceName.length == 0 ? '#616161' : '#0465AC', cursor: this.state.selectedResourceName.length == 0 ? 'not-allowed' : 'pointer' }} disabled={this.state.selectedResourceName.length == 0}
                                    onClick={() => this.library_updateResourceParentId()}
                                >Update Parent Resource</button>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Method to open add modal
    addOrEditResourceModal = () => {

        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['resource'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {

            this.setState({
                addResource: true,
            })

        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // Method to close add or edit modal
    closeAddResource = () => {
        this.setState({
            addResource: false,
            AccessionSeries: '',
            AccessionNumber: '',
            NoOfCopies: 1,
            AccessionDate: '',
            CallIndexSeries: '',
            CallNumber: '',
            Title: '',
            Author: '',
            ResourceVolume: '',
            ResourceEdition: '',
            ResourceLanguage: '',
            Publisher: '',
            NumberOfPages: '',
            NumberOfPreliminaryPages: '',
            ResourceCategory: '',
            YearOfPublication: '',
            Department: '',
            ResourceType: '',
            TranslatorName: '',
            Translated: 'Yes',
            SearchKeyword: '',
            Location: '',
            IsbnNumber: '',
            ResourceCondition: { label: 'Good', value: 'Good' },
            MarkAsDonated: '',
            DonorName: '',
            ResourceAttachment: [],
            SpecimenCopy: false,
            InvoiceBillNo: '',
            InvoiceBillDate: '',
            Price: '1',
            Discount: '',
            CopyNetPrice: '',
            TotalCopiesNetPrice: '',
            accessError: '',
            typeOfIIDScreen: '',
            addResourceInstituteIID: [{
                value: config.institute_id,
                label: this.props?.multipleInstituteDetails?.multipleInstituteDetails?.[config.institute_id]?.institute_name || ''
            }],
        }, () => {
            this.apiCallToGetAccessionSeries()
            this.apiCallToGetInstituteStreamList()
            this.getPublisherList()
            this.GetLibraryResourceCategoryListWithBasicDetails()
            this.GetLibraryLocationList()
            this.apiCallToGetDonorsList()
            this.getLibraryInvoiceListDataStatus()
        })
    }

    // This function is used to accession number increment
    incrementLeadingZeroNumber = (leadingZeroString, amountToIncrement) => {
        var amountOfZerosToAdd = leadingZeroString.length;
        var stringToNumber = (+leadingZeroString);
        var zerosToAdd = new Array(amountOfZerosToAdd + 1).join('0');

        var zerosAndNewNumber = zerosToAdd + (stringToNumber + amountToIncrement)
        var amountToSlice = (-1 * amountOfZerosToAdd)
        var newString = zerosAndNewNumber.slice(amountToSlice)
        return newString
    }

    incrementAlphanumericAccessionNumber = (str) => {
        str = str.toString();
        const match = str.match(/(\d+)$/); // Match trailing number, if any

        // Simulate incrementLeadingZeroNumber
        const incrementLeadingZeroNumber = (numStr, incrementBy) => {
            const incremented = (parseInt(numStr, 10) + incrementBy).toString();
            return numStr.length > incremented.length
                ? '0'.repeat(numStr.length - incremented.length) + incremented
                : incremented;
        };

        if (match) {
            const numPart = match[0];
            const strPart = str.slice(0, str.lastIndexOf(numPart));
            return strPart + incrementLeadingZeroNumber(numPart, 1);
        } else {
            // No numeric suffix: just append "1"
            return str + "1";
        }

        // str = str.toString();
        // const numPart = str.match(/([0-9])+$|([0-9]+)$/)[0];
        // const strPart = str.slice(0, str.indexOf(numPart));
        // const isLastIndexNine = numPart.match(/9$/);

        // let incrementedNumber = '';
        // // If we have a leading zero (e.g. - 'L100A099') 
        // // or there is no prefix - we should just increment the number
        // if (isLastIndexNine || strPart != null) {
        //     incrementedNumber = strPart + numPart.replace(/\d+$/, (n) => this.incrementLeadingZeroNumber(n, 1));
        // }
        // // Increment the number and add the missing zero
        // else {
        //     incrementedNumber = strPart + '0' + numPart.replace(/\d+$/, (n) => ++n);
        // }
        // return incrementedNumber;
    }

    GetMaximumLibraryAccession = async (from) => {
        this.setState({
            loadingGetMaximumLibraryAccession: true,
        })

        let addResourceIID = '';
        if (this.state.addResourceInstituteIID.length > 0) {
            addResourceIID = this.state.addResourceInstituteIID[0].value
        } else {
            addResourceIID = this.state.addResourceInstituteIID.value
        }

        let requestData = {
            iid: this.state.typeOfIIDScreen == 'Add' ? addResourceIID : config.institute_id,
            accesseriesid: this.state.AccessionSeries.uniqueId
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetMaximumLibraryAccession',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetMaximumLibraryAccession();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetMaximumLibraryAccessionValue: apiResult.data,
                    loadingGetMaximumLibraryAccession: false,
                })
                if (this.state.GetMaximumLibraryAccessionValue == null) {
                    this.state.GetMaximumLibraryAccessionValue = 1;
                }
                else {
                    // this function is used to accession number increment
                    this.state.GetMaximumLibraryAccessionValue = this.incrementAlphanumericAccessionNumber(this.state.GetMaximumLibraryAccessionValue);
                }
                this.setState({ AccessionNumber: this.state.GetMaximumLibraryAccessionValue })
                if (from == 'addresource') {
                    this.setState({ AccessionNumber: this.state.GetMaximumLibraryAccessionValue, NoOfCopies: 1, accessError: "Accession number from " + this.state.GetMaximumLibraryAccessionValue + " to " + this.state.GetMaximumLibraryAccessionValue })
                    // accessionNoflag = false;
                }
            } else {
                this.setState({
                    loadingGetMaximumLibraryAccession: false,
                })
            }
        }
    }

    //API CALL METHOD to get library call number series list
    getCallIndexSeriesList = async () => {
        let addResourceIID = '';
        if (this.state.addResourceInstituteIID.length > 0) {
            addResourceIID = this.state.addResourceInstituteIID[0].value
        } else {
            addResourceIID = this.state.addResourceInstituteIID.value
        }

        let requestData = {
            iid: this.state.typeOfIIDScreen == 'Add' ? addResourceIID : config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'libraryGetCallNumberSeriesList',
            requestData,
            '/api/library/libraryCallNumberSeries.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getCallIndexSeriesList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    libraryCallIndexSeriesList: apiResult.data,
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting call number series list. Please try again later.'
                });
            }
        }
    }

    //function to check accession number 00
    checkAccessionNumber = async (source, from) => {
        let Accessseriesid = "";
        //for add source
        if (from == "noofcopies" || from == "addaccessionno") {
            Accessseriesid = this.state.AccessionSeries.uniqueId
        }

        if (source) {
            if (this.state.AccessionSeries != "") {
                //create an array containing accession numbers
                let accessionNo = ""
                if (from != "noofcopies") {
                    accessionNo = source;
                }
                else if (from == "noofcopies") {
                    accessionNo = this.state.AccessionNumber;
                }
                if (accessionNo != "") {

                    //check if accession no positive integer
                    if (accessionNo != 0) {
                        accessionNo = accessionNo.toString();

                        // Match trailing digits, if any
                        const match = accessionNo.match(/(\d+)$/);
                        let numPart = '0';
                        let strPart = accessionNo;

                        if (match) {
                            numPart = match[0];
                            strPart = accessionNo.slice(0, accessionNo.lastIndexOf(numPart));
                        }

                        const isLastIndexNine = numPart.endsWith('9');

                        let AccessionNumberArray = [];
                        let noofcopies = this.state.NoOfCopies;

                        // If there's a numeric part
                        if (isLastIndexNine || strPart != null) {
                            accessionNo = parseInt(numPart, 10);
                            if (noofcopies && noofcopies !== '0') {
                                for (let i = 0; i < parseInt(noofcopies); i++) {
                                    let temp = strPart + accessionNo.toString().padStart(numPart.length, '0');
                                    AccessionNumberArray.push(temp);
                                    accessionNo++;
                                }
                            } else {
                                AccessionNumberArray = [strPart + accessionNo.toString().padStart(numPart.length, '0')];
                            }
                        } else {
                            // If no numeric part, start from 1
                            accessionNo = 1;
                            if (noofcopies && noofcopies !== '0') {
                                for (let i = 0; i < parseInt(noofcopies); i++) {
                                    AccessionNumberArray.push(strPart + accessionNo.toString().padStart(numPart.length, '0'));
                                    accessionNo++;
                                }
                            } else {
                                AccessionNumberArray = [strPart + accessionNo.toString().padStart(numPart.length, '0')];
                            }
                        }

                        // const numPart = accessionNo.match(/([0-9])+$|([0-9]+)$/)[0];
                        // const strPart = accessionNo.slice(0, accessionNo.indexOf(numPart));
                        // const isLastIndexNine = numPart.match(/9$/);


                        // let AccessionNumberArray = [];
                        // //codeto get no of copies            
                        // let noofcopies = this.state.NoOfCopies;
                        // // If Accession Number MM00001
                        // if (isLastIndexNine || strPart != null) {

                        //     accessionNo = parseInt(numPart);
                        //     if (noofcopies != "" && noofcopies != '0') {
                        //         for (let i = 0; i < parseInt(noofcopies); i++) {
                        //             let temp = "";
                        //             temp = strPart + "" + accessionNo;
                        //             AccessionNumberArray.push(temp);
                        //             accessionNo++
                        //         }
                        //     }
                        //     else {
                        //         AccessionNumberArray = [accessionNo];
                        //     }
                        // }
                        // else // accession number 1
                        // {
                        //     accessionNo = parseInt(accessionNo);
                        //     if (noofcopies != "" && noofcopies != '0') {
                        //         for (let i = 0; i < parseInt(noofcopies); i++) {

                        //             AccessionNumberArray.push(accessionNo);
                        //             accessionNo++;
                        //         }
                        //     }
                        //     else {
                        //         AccessionNumberArray = [accessionNo];
                        //     }
                        // }

                        //code to create accession series id array
                        let accessionsertiesidArray = [Accessseriesid];

                        let extraParam = {
                            source: source,
                            from: from,
                            AccessionNumberArray: AccessionNumberArray
                        }

                        let requestData = {
                            iid: config.institute_id,
                            accessionNoArray: AccessionNumberArray,
                            seriesIdArray: accessionsertiesidArray
                        };

                        let jsonResponse = await LibraryApiCall.makeApiCall(
                            "checkAccessionNumber",
                            requestData,
                            "/api/library/instructor.php"
                        );

                        if (jsonResponse.success) {
                            let apiResult = jsonResponse.APIResult;
                            if (apiResult["status"] == "fail") {
                                //for add source
                                if (from == "noofcopies" || from == "addaccessionno") {
                                    // accessionNoflag = true;
                                    this.setState({ accessError: "Accession number is already assigned to other resource.Kindly change accession number." })
                                }
                            }
                            else {
                                //add resource
                                if (from == "noofcopies" || from == "addaccessionno") {
                                    // accessionNoflag = false;
                                    this.setState({ accessError: "Accession number from " + AccessionNumberArray[0] + " to " + (AccessionNumberArray[AccessionNumberArray.length - 1]) })
                                }
                            }
                        }
                    }
                    else {
                        //for add source
                        if (from == "noofcopies" || from == "addaccessionno") {
                            this.setState({ accessError: "Invalid accession number.", AccessionNumber: '' })
                        }
                    }
                }
            }
            else {
                //for add source
                if (from == "noofcopies" || from == "addaccessionno") {
                    this.setState({ accessError: "Kindly select accession series.", AccessionNumber: '' })
                }
            }
        }
        // else {
        //     this.setState({ accessError: "Kindly enter accession number." })
        // }
    }

    //function to calculate netPrice 00
    calculateNetPrice = () => {
        var discount = this.state.Discount;
        var price = this.state.Price;
        var noOfCopies = this.state.NoOfCopies;
        if (noOfCopies != "" && noOfCopies != "0") {
            noOfCopies = parseInt(noOfCopies);
        }
        else {
            noOfCopies = 1;
        }
        if (discount != "" && price != "") {
            discount = discount;
            // price = parseInt(price);
            price = parseFloat(price);
            let netpriceval = price - parseFloat((price * discount) / 100).toFixed(2);
            let netPricetotal = netpriceval * noOfCopies;
            this.setState({ CopyNetPrice: netpriceval.toFixed(2), TotalCopiesNetPrice: netPricetotal.toFixed(2) })
        }
        if (price == "" || price == "0") {
            this.setState({ CopyNetPrice: '', TotalCopiesNetPrice: '' })
        }
        if (discount == "" || discount == "0") {
            this.state.CopyNetPrice = this.state.Price
            var noOfCopies = this.state.NoOfCopies;
            if (noOfCopies != "" && noOfCopies != "0") {
                noOfCopies = parseInt(noOfCopies);
            }
            else {
                noOfCopies = 1;
            }
            var addprice = this.state.Price;
            if (addprice != "" && addprice != "0") {
                // addprice = parseInt(addprice);
                addprice = parseFloat(addprice);
            }
            else {
                addprice = 0;
            }
            this.setState({ TotalCopiesNetPrice: (addprice * noOfCopies).toFixed(2) })
        }
    }
    //function to calculate netPrice 11

    //function to get maximum call no 00         
    GetLibraryCallNumber = (source, from = 'addresource') => {
        let selectedSid = source.value;

        if (this.state.libraryCallIndexSeriesList[selectedSid] != undefined) {
            this.setState({
                CallNumber: this.state.libraryCallIndexSeriesList[selectedSid]['series_text']
            })
        }
        else {
            this.setState({
                CallNumber: ''
            })
        }

    }

    //function to get invoice date        
    GetLibraryInvoiceDate = (selectedOption) => {
        const selectedInvoiceId = selectedOption.value;

        // Find the corresponding invoice from the GetInvoiceDataList
        const selectedInvoice = this.state.GetInvoiceDataList.find(
            (item) => item.billno === selectedInvoiceId
        );

        if (selectedInvoice) {
            // Update the state with the selected invoice date
            this.setState({
                InvoiceBillDate: selectedInvoice.billdate
            });
        } else {
            this.setState({
                InvoiceBillDate: '' // Clear date if no match found
            });
        }
    }

    // METHOD TO CLICK ON INPUT TYPE FILE
    getAttachmentClick = () => {
        document.getElementById('attachment-files').click();
    }

    // METHOD TO EMPTY DATA ON FILE CLICK
    onFileClick = (e) => {
        e.target.value = "";
    }

    // METHOD TO GET ATTACHMENT FILES
    getAttachments = (e) => {
        let attachments = this.state.ResourceAttachment;
        let validData = true;
        let fileData = [e.target.files[0]];
        Object.values(fileData).map(file => {
            let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
            let fileSize = file.size / 1048576;
            if (fileExtension != 'jpeg' || fileExtension != 'jpg' || fileExtension != 'png') {
                this.setState({
                    fileSelectionWarning: 'Please select files with .jpeg, .jpg, .png only.'
                });
                validData = false;
            } else {
                this.setState({
                    fileSelectionWarning: ''
                });
                validData = true;
            }

            if (fileSize > 5) {
                this.setState({
                    fileSelectionWarning: 'Please select file less than 5MB.'
                });
                validData = false;
            } else {
                this.setState({
                    fileSelectionWarning: ''
                });
                validData = true;
            }

            if (validData) {
                attachments.push(file);
                this.setState({
                    attachments,
                    ResourceAttachment: fileData,
                    fileSelectionWarning: ''
                });
            }
        });
    }

    // METHOD TO REMOVE ADD ATTACHMENT
    removeAddAttachment = (file) => {

        let attachments = this.state.ResourceAttachment;
        attachments = this.state.ResourceAttachment.filter(attachFile => attachFile.name != file.name);

        this.setState({
            attachments,
            ResourceAttachment: attachments
        });
    }

    stripHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    }


    // Add Resource API Call
    validateResourceSubmission = async () => {
        let validData = true;

        if (!this.state.AccessionSeries) {
            this.setState({
                accessionSeriesWarning: 'Please select accession series.'
            });
            validData = false;
        }

        if (!this.state.AccessionNumber) {
            this.setState({
                accessionNumberWarning: 'Please enter accession number.'
            });
            validData = false;
        }

        if (!this.state.Title) {
            this.setState({
                resourceTitleWarning: 'Please select/enter resource title.'
            });
            validData = false;
        }

        if (!this.state.Author) {
            this.setState({
                resourceAuthorWarning: 'Please select/enter resource author.'
            });
            validData = false;
        }

        if (!this.state.ResourceLanguage) {
            this.setState({
                resourceLanguageWarning: 'Please select resource language.'
            });
            validData = false;
        }

        if (!this.state.Publisher) {
            this.setState({
                publisherWarning: 'Please select publisher.'
            });
            validData = false;
        }


        if (!this.state.ResourceCategory) {
            this.setState({
                resourceCategoryWarning: 'Please select resource category.'
            });
            validData = false;
        }

        if (!this.state.ResourceType) {
            this.setState({
                resourceTypeWarning: 'Please select resource type.'
            });
            validData = false;
        }
        if (!this.state.MarkAsDonated) {
            if (!/^\d+(\.\d{1,2})?$/.test(this.state.Price) || parseInt(this.state.Price) <= 0) {
                this.setState({
                    priceWarning: 'Please enter a valid decimal number (up to 2 decimals).'
                });
                validData = false;
            }
        }

        if (validData) {

            // publisher data
            const publisherid = JSON.stringify(this.state.Publisher?.map(item => item.value));
            const publisherNames = this.state.Publisher?.map(p => p.label).join(', ');
            const encodedPublisherNames = encodeURIComponent(' ' + publisherNames);

            // resource category data
            const categroyid = JSON.stringify(this.state.ResourceCategory?.map(item => item.value));
            const categoryNames = this.state.ResourceCategory?.map(p => p.label).join(', ');
            const encodedCategoryNames = encodeURIComponent(' ' + categoryNames);

            // Department data
            const departmentid = this.state.Department ? JSON.stringify(this.state.Department?.map(item => item.value)) : '';

            let resourceDetails = {
                "accessionseriesid": this.state.AccessionSeries.uniqueId || '',
                "accessionnumber": this.state.AccessionNumber || '',
                "number_of_copies": this.state.NoOfCopies || '',
                "accession_date": this.state.AccessionDate || '',
                "callindexseriesid": this.state.CallIndexSeries.value || '',
                "callNumber": this.state.CallNumber || '',
                "title": Base64.encode(this.state.Title?.label),
                "author": Base64.encode(this.state.Author?.label),
                "volume": this.state.ResourceVolume || '',
                "edition": this.state.ResourceEdition || '',
                "resource_lang": this.state.ResourceLanguage.value || '',
                "publisherName": encodedPublisherNames,
                "publisherid": publisherid,
                "number_of_pages": this.state.NumberOfPages || '',
                "preliminarypages": this.state.NumberOfPreliminaryPages || '',
                "resourceCategoryName": encodedCategoryNames,
                "resourceCategory": categroyid,
                "yearOfPublication": this.state.YearOfPublication || '',
                "stream": departmentid,
                "resource_type": this.state.ResourceType.label || '',
                "translatorName": this.state.TranslatorName || '',
                "Translated": this.state.Translated || '',
                "keyword": this.state.SearchKeyword || '',
                "locationName": this.state.Location.label || '',
                "location": this.state.Location.value || '',
                "isbn_number": this.state.IsbnNumber || '',
                "resource_condition": this.state.ResourceCondition.label || '',
                "addResourceDonorName": this.state.DonorName.name || '',
                "resourceDonor": this.state.DonorName.value || '',
                "invoiceno": this.state.InvoiceBillNo.invoiceId || '',
                "medium": "Physical",
                "donated": this.state.MarkAsDonated ? "Donated" : "Not Donated",
                "donor_id": this.state.DonorName.value || '',
                "bill_date": "",
                "price": this.state.Price || '1',
                "discount": this.state.Discount || '',
                "billNumber": "",
                "specimen": this.state.SpecimenCopy ? "true" : "false",
                "netprice": this.state.CopyNetPrice || '',
                "eresource_path": "",
                "eresource_access": ""
            }

            this.setState({
                addResourceLoading: true
            });

            let addResourceIID = '';
            if (this.state.addResourceInstituteIID.length > 0) {
                addResourceIID = this.state.addResourceInstituteIID[0].value
            } else {
                addResourceIID = this.state.addResourceInstituteIID.value
            }

            let requestData = {
                "iid": addResourceIID, // config.institute_id,
                "resourceDetails": resourceDetails,
                "facultyId": config.faculty_id,
                "resourceAttachment": ""
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'AddNewLibraryResource',
                requestData,
                "/api/library/instructor.php",
                this.state.ResourceAttachment
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.validateResourceSubmission()
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;

                    if (apiResult.status == 'success') {
                        this.setState({
                            successModal: true,
                            successModalType: 'success',
                            successMessage: this.stripHtml(apiResult.message),
                            addResourceLoading: false,
                            priceWarning: ""
                        });
                        this.closeAddResource()
                        this.GetLibraryResourceBasicDetailsList();
                    } else {
                        this.setState({
                            successModal: true,
                            successModalType: 'warning',
                            successMessage: this.stripHtml(apiResult.message),
                            addResourceLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while updating Resource. Please try again later.',
                        addResourceLoading: false
                    });
                }
            }
        }
    }

    // METHOD TO RETURN ADD Resource
    returnAddResource = () => {
        // custom category and sub-category data list
        categorySubCategoryData = Object.values(this.state.GetResourceCategoryList).flatMap(item => {
            // Start with the category itself
            const categoryOption = {
                value: item.value,
                label: item.name,
                isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
            };

            // If the category has subcategories, add those as well
            const subCategoryOptions = item.subCategories.map(subCategory => ({
                value: subCategory.subCategoryId,
                label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                isDisabled: false, // Subcategory is always enabled
            }));

            // Return the category option followed by the subcategory options
            return [categoryOption, ...subCategoryOptions];
        });

        // custom location and sub-location data list
        locationSubLocationData = Object.values(this.state.GetLocationList)?.flatMap((data) => {
            // Start with the parent location itself
            const locationOption = {
                value: data.value,
                label: data.name,
                isDisabled: data.sublocations && data.sublocations.length > 0, // Disable the parent if it has sublocations
            };

            // If the location has sublocations, add them as well
            const subLocationOptions = data.sublocations?.map((sublocation) => ({
                value: sublocation.sublocationId,
                label: `${data.name} => ${sublocation.sublocationName}`, // Parent location followed by sublocation name
                isDisabled: false, // Subcategory is always enabled
            }));

            // Return the location option followed by the sublocation options
            return [locationOption, ...subLocationOptions];
        })

        const truncateText = (text = "", limit = 10) => {
            if (!text) return "";
            return text.length > limit ? text.substring(0, limit) + "..." : text;
        };

        const buildInvoiceLabel = (item, full = false) => {
            let parts = [];
            
            if (item.billno) parts.push(item.billno);
            if (item.billdate) parts.push(item.billdate);
            if (item.vendorName) parts.push(item.vendorName);

            if (item.note) {
                parts.push(full ? item.note : truncateText(item.note, 10));
            }

            return parts.join(" | ");
        };

        return (
            <div id="addAccessSideMenu" style={{ display: this.state.addResource ? 'flex' : 'none' }}>
                <div id="addResourceDataContainer">
                    {/* header */}
                    <div id="addAccessHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeAddResource()} style={{ cursor: "pointer" }} />
                        <h5 style={{ paddingLeft: '40%' }} className="col-11">Add Resource</h5>
                    </div>

                    {/* content */}
                    <div className='col-md-12 pl-4 pt-2 pb-3'>
                        <div className='col-md-4 pl-0'>
                            <label className='fs-14 fieldHeadColor '>Select Institute<span className='text-danger'>*</span></label>
                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                <Select
                                    options={Object.values(this.state.multipleInstituteDetails).map(item => ({
                                        value: item.iid,
                                        label: item.institute_name,
                                    }))}
                                    value={this.state.addResourceInstituteIID}
                                    className="basic-multi-select-filter"
                                    onChange={(event) => {
                                        this.setState({
                                            typeOfIIDScreen: 'Add',
                                            addResourceInstituteIID: event || [], // Handle empty selection 
                                            AccessionSeries: '',
                                            AccessionNumber: '',
                                            CallIndexSeries: '',
                                            CallNumber: '',
                                            Publisher: '',
                                            ResourceCategory: '',
                                            Department: '',
                                            Location: '',
                                            DonorName: '',
                                            InvoiceBillNo: ''
                                        }
                                            , () => {
                                                this.apiCallToGetAccessionSeries()
                                                // this.apiCallToGetInstituteStreamList()
                                                this.getInstituteStreamsObject()
                                                this.getPublisherList()
                                                this.GetLibraryResourceCategoryListWithBasicDetails()
                                                this.GetLibraryLocationList()
                                                this.apiCallToGetDonorsList()
                                                this.getLibraryInvoiceListDataStatus()
                                                this.getCallIndexSeriesList()
                                            }
                                        );
                                    }}
                                    placeholder="Select Institute"
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            width: '100%',
                                            minHeight: 42, // Minimum height for the control area
                                            height: 'auto', // Allow control to grow dynamically
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                        }),
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            fontSize: '12px',
                                            fontWeight: 400,
                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            fontSize: '12px',
                                            fontWeight: 400,
                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                            color: state.isSelected ? '#333' : '#555',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '12px',
                                            fontWeight: '400',
                                        }),
                                    }}
                                    menuPortalTarget={document.body}
                                    required
                                />
                                <p style={{ display: this.state.accessionSeriesWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.accessionSeriesWarning}</p>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 pl-4 pt-2 pb-3'>
                        <p className='fs-16 pb-3 fw-600' style={{ color: '#0465AC' }}>Accession Details</p>
                        <div className='d-flex pb-3'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Accession Series <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={Object.values(this.state.accessionSeriesList)}
                                        value={this.state.AccessionSeries}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                AccessionSeries: event || [], // Handle empty selection
                                                AccessionNumber: '',
                                                accessionSeriesWarning: ''
                                            }, () => this.GetMaximumLibraryAccession('addresource')
                                            );
                                        }}
                                        placeholder="Select Accession Series"
                                        isClearable
                                        isLoading={this.state.isFilterLoading} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.isFilterLoading ? "Loading..." : "No options found")}
                                        required
                                    />
                                    <p style={{ display: this.state.accessionSeriesWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.accessionSeriesWarning}</p>
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Accession Number <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="addAccessionNumber"
                                        placeholder="Enter Accession Number"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.AccessionNumber} // Bind value to state
                                        onChange={(e) => {
                                            this.setState({
                                                AccessionNumber: e.target.value || '',
                                                accessionNumberWarning: ''
                                            }, () => {
                                                this.checkAccessionNumber(this.state.AccessionNumber, 'addaccessionno')
                                            })
                                        }}
                                        maxLength={20}
                                        required
                                    />
                                    <p style={{ display: this.state.accessionNumberWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.accessionNumberWarning}</p>
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 20 characters are allowed)</p>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Number of Copies</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="number"
                                        className="form-control formControlAutoTask"
                                        id="addNumberOfCopies"
                                        placeholder="Enter Number of Copies"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.NoOfCopies} // Bind value to state
                                        onChange={(e) => {
                                            const input = e.target.value;

                                            // Allow only digits
                                            if (/^\d*$/.test(input)) {
                                                const numericValue = Number(input);

                                                // Allow only values from 1 to 50000
                                                if ((numericValue >= 1 && numericValue <= 50000) || input === '') {
                                                    this.setState({ NoOfCopies: input }, () => {
                                                        this.checkAccessionNumber(this.state.NoOfCopies, 'noofcopies');
                                                    });
                                                }
                                            }
                                        }}
                                        min={1}
                                        max={50000}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 50000 copies are allowed)</p>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Accession Date</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                        placeholder="Select Accession Date"
                                        value={this.state.AccessionDate}
                                        onChange={(event) => {
                                            const selectedDate = event.target.value;

                                            if (selectedDate) {
                                                const year = selectedDate.split("-")[0];
                                                if (year.length === 4 && !isNaN(parseInt(year))) {
                                                    this.setState({
                                                        AccessionDate: selectedDate,
                                                        accessionDateWarning: "" // clear any previous error
                                                    });
                                                } else {
                                                    this.setState({
                                                        accessionDateWarning: "Year must be a 4-digit number.",
                                                        AccessionDate: ''
                                                    });
                                                }
                                            } else {
                                                this.setState({
                                                    AccessionDate: '',
                                                    accessionDateWarning: ''
                                                });
                                            }
                                        }}

                                    />
                                </div>
                                {this.state.accessionDateWarning && (
                                    <p style={{ color: 'red', fontSize: 12 }}>{this.state.accessionDateWarning}</p>
                                )}
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Call Index Series</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={Object.values(this.state.GetStreamList).map(item => ({
                                            value: item.sid,
                                            label: item.name,
                                        }))}
                                        value={this.state.CallIndexSeries}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                CallIndexSeries: event || [], // Handle empty selection
                                            }, () => {
                                                this.GetLibraryCallNumber(this.state.CallIndexSeries)
                                            });
                                        }}
                                        placeholder="Select Call Index Series"
                                        isClearable
                                        isLoading={this.state.loadingStreamData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingStreamData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Call Number</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Call Number"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.CallNumber} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                CallNumber: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        maxLength={250}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 250 characters are allowed)</p>
                            </div>
                        </div>
                        <p className='fs-14 fieldHeadColor'>{this.state.accessError}</p>
                    </div>

                    <div className='col-md-12 pl-4 pt-2'>
                        <p className='fs-16 pb-1 fw-600' style={{ color: '#0465AC' }}>Resource Details</p>
                        <div className='d-flex pb-3'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Title <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={this.state.GetResourceTitleList}
                                        value={this.state.Title}
                                        className="basic-multi-select-filter"
                                        onChange={(selectedOption) => {
                                            this.setState({
                                                Title: selectedOption || null,
                                                searchByTitle: selectedOption ? selectedOption.label : ""
                                            });
                                        }}
                                        onInputChange={(inputValue, { action }) => {
                                            if (action === "input-change") {
                                                this.setState({ searchByTitle: inputValue, searchByAuthor: "" }, () => {
                                                    this.library_getResourceAuthorDetails();
                                                });
                                            }
                                            if (action === "clear") {
                                                this.setState({ searchByTitle: "", Title: null });
                                            }
                                        }}
                                        onBlur={() => {
                                            const typedValue = this.state.searchByTitle?.trim();
                                            if (typedValue) {
                                                // if user typed but didn’t pick, store typed value
                                                if (!this.state.Title || this.state.Title.label !== typedValue) {
                                                    this.setState({
                                                        Title: { value: typedValue, label: typedValue }
                                                    });
                                                }
                                            } else {
                                                // empty → clear
                                                this.setState({ Title: null, searchByTitle: "" });
                                            }
                                        }}
                                        placeholder="Select Title"
                                        isClearable
                                        isLoading={this.state.loadingTitleAuthorData}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42,
                                                height: 'auto',
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() =>
                                            this.state.loadingTitleAuthorData ? "Loading..." : "No options found"
                                        }
                                    />
                                    <p style={{ display: this.state.resourceTitleWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.resourceTitleWarning}</p>
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Author <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={this.state.GetResourceAuthorList}
                                        value={this.state.Author}
                                        className="basic-multi-select-filter"
                                        onChange={(selectedOption) => {
                                            this.setState({
                                                Author: selectedOption || null,
                                                searchByAuthor: selectedOption ? selectedOption.label : ""
                                            });
                                        }}
                                        onInputChange={(inputValue, { action }) => {
                                            if (action === "input-change") {
                                                this.setState({ searchByAuthor: inputValue, searchByTitle: "" }, () => {
                                                    this.library_getResourceAuthorDetails();
                                                });
                                            }
                                            if (action === "clear") {
                                                this.setState({ searchByAuthor: "", Author: null });
                                            }
                                        }}
                                        onBlur={() => {
                                            const typedValue = this.state.searchByAuthor?.trim();
                                            if (typedValue) {
                                                if (!this.state.Author || this.state.Author.label !== typedValue) {
                                                    this.setState({
                                                        Author: { value: typedValue, label: typedValue }
                                                    });
                                                }
                                            } else {
                                                this.setState({ Author: null, searchByAuthor: "" });
                                            }
                                        }}
                                        placeholder="Select Author"
                                        isClearable
                                        isLoading={this.state.loadingTitleAuthorData}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42,
                                                height: 'auto',
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() =>
                                            this.state.loadingTitleAuthorData ? "Loading..." : "No options found"
                                        }
                                        required
                                    />
                                    <p style={{ display: this.state.resourceAuthorWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.resourceAuthorWarning}</p>
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Resource Volume</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Resource Volume"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.ResourceVolume} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                ResourceVolume: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        maxLength={250}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 250 characters are allowed)</p>
                            </div>
                        </div>
                        <div className='d-flex pb-3'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Resource Edition</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Resource Edition"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.ResourceEdition} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                ResourceEdition: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        maxLength={100}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 100 characters allowed)</p>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Resource Language <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={resourceLanguageData.map(item => ({
                                            value: item,
                                            label: item,
                                        }))}
                                        value={this.state.ResourceLanguage}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                ResourceLanguage: event || [], // Handle empty selection
                                                resourceLanguageWarning: ''
                                            });
                                        }}
                                        placeholder="Select Resource Language"
                                        isClearable
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        required
                                    />
                                    <p style={{ display: this.state.resourceLanguageWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.resourceLanguageWarning}</p>
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Publisher <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetPublisherList).map(item => ({
                                            value: item.value,
                                            label: item.name,
                                        }))}
                                        value={this.state.Publisher}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                Publisher: event || [], // Handle empty selection
                                                publisherWarning: ''
                                            });
                                        }}
                                        placeholder="Search & Select Publisher"
                                        isLoading={this.state.loadingPublisherData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingPublisherData ? "Loading..." : "No options found")}
                                        required
                                    />
                                    <p style={{ display: this.state.publisherWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.publisherWarning}</p>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex pb-3'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Number of Pages</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Number of Pages"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.NumberOfPages} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                NumberOfPages: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Number of Preliminary Pages</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Number of Preliminary Pages"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.NumberOfPreliminaryPages} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                NumberOfPreliminaryPages: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Resource Category <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={categorySubCategoryData}
                                        value={this.state.ResourceCategory}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                ResourceCategory: event || [], // Handle empty selection
                                                resourceCategoryWarning: ''
                                            });
                                        }}
                                        placeholder="Search & Select Resource Category"
                                        isLoading={this.state.loadingResourceCategoryData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isDisabled ? '#f0f0f0' : state.isFocused ? '#e0e0e0' : 'white',
                                                color: state.isDisabled ? '#999' : '#555',
                                                cursor: state.isDisabled ? 'not-allowed' : 'default',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingResourceCategoryData ? "Loading..." : "No options found")}
                                        required
                                    />
                                    <p style={{ display: this.state.resourceCategoryWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.resourceCategoryWarning}</p>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex pb-3'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Year of Publication <p style={{ color: '#7A7A7A', fontSize: '12px', display: 'inline', margin: '0' }}>(Ex.2018, 2018-2019)</p></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Year of Publication"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.YearOfPublication}
                                        onChange={(e) => {
                                            const input = e.target.value;

                                            // ✅ Regex allows partial typing states:
                                            // - ^\d{0,4}                  → up to 4 digits
                                            // - (-(\d{0,2}|\d{0,4}))?     → optional hyphen with 2 or 4 digits
                                            // - $ ensures nothing else
                                            const isValid = /^\d{0,4}(-(\d{0,2}|\d{0,4}))?$/.test(input);

                                            if (isValid) {
                                                this.setState({
                                                    YearOfPublication: input,
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Department</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetStreamList).map(item => ({
                                            value: item.sid,
                                            label: item.name,
                                        }))}
                                        value={this.state.Department}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                Department: event || [], // Handle empty selection
                                            });
                                        }}
                                        placeholder="Search & Select Department"
                                        isLoading={this.state.loadingStreamData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingStreamData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Resource Type <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={resourceTypeData.map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                        value={this.state.ResourceType}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                ResourceType: event || [], // Handle empty selection
                                                resourceTypeWarning: ''
                                            });
                                        }}
                                        placeholder="Select Resource Type"
                                        isClearable
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        required
                                    />
                                    <p style={{ display: this.state.resourceTypeWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.resourceTypeWarning}</p>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex pb-3'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Translator Name</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Translator Name"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.TranslatorName} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                TranslatorName: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        maxLength={250}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 250 characters are allowed)</p>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Translated</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <div style={{ marginRight: '15px' }}>
                                        <input
                                            type="radio"
                                            name="Translated"
                                            checked={this.state.Translated == 'Yes'}
                                            onChange={() => this.setState({ Translated: 'Yes' })}
                                            style={{ marginRight: 5 }}
                                        />
                                        <span style={{ fontSize: 13 }}>Yes</span>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            name="Translated"
                                            checked={this.state.Translated == 'No'}
                                            onChange={() => this.setState({ Translated: 'No' })}
                                            style={{ marginRight: 5 }}
                                        />
                                        <span style={{ fontSize: 13 }}>No</span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Search Keyword</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Search Keyword"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.SearchKeyword} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                SearchKeyword: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        maxLength={250}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(For multiple, use comma(,) to separate.Maximum 250 characters are allowed)</p>
                            </div>
                        </div>
                        <div className='d-flex pb-3'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Location</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={locationSubLocationData}
                                        value={this.state.Location}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                Location: event || [], // Handle empty selection
                                            });
                                        }}
                                        placeholder="Select Location"
                                        isClearable
                                        isLoading={this.state.loadingLocationData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isDisabled ? '#f0f0f0' : state.isFocused ? '#e0e0e0' : 'white',
                                                color: state.isDisabled ? '#999' : '#555',
                                                cursor: state.isDisabled ? 'not-allowed' : 'default',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingLocationData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>ISBN Number</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter ISBN Number"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.IsbnNumber} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                IsbnNumber: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        maxLength={20}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 20 characters are allowed)</p>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Resource Condition</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={resourceConditionData.map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                        value={this.state.ResourceCondition}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                ResourceCondition: event || [], // Handle empty selection
                                            });
                                        }}
                                        placeholder="Select Resource Condition"
                                        isClearable
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='d-flex pb-3'>
                            <div className='col-md-4 pl-0'>
                                <input
                                    type='checkbox'
                                    onChange={(event) => {
                                        this.setState({
                                            MarkAsDonated: event.target.checked, // Set true or false based on checkbox state
                                            DonorName: '',
                                            InvoiceBillNo: '',
                                            InvoiceBillDate: '',
                                            Price: '',
                                            Discount: '',

                                        });
                                    }}
                                    checked={this.state.MarkAsDonated}
                                    style={{ marginRight: 5 }}
                                /><label className='fs-14 fieldHeadColor '>Mark as donated</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={this.state.donorsListData}
                                        value={this.state.DonorName}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                DonorName: event || [], // Handle empty selection
                                            });
                                        }}
                                        onInputChange={(inputValue) => {
                                            this.setState({ searchByDonorName: inputValue }, () => {
                                                this.apiCallToGetDonorsList(); // Trigger the API call after updating the search term
                                            }, 200);
                                        }}
                                        isDisabled={!this.state.MarkAsDonated}
                                        placeholder="Select Donor"
                                        isClearable
                                        isLoading={this.state.loadingDonorsData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingDonorsData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Attach Image of Resource</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    {/* <p className="total-attachments">Total {this.state.ResourceAttachment.length} Attachment</p> */}
                                    {
                                        this.state.ResourceAttachment.length > 0 &&
                                        Object.values(this.state.ResourceAttachment).map((attachment, index) => {
                                            return (
                                                <p className="attachedFile-name">
                                                    {attachment.name}
                                                    <FontAwesomeIcon icon={['fas', 'times']} size="lg" title="Click to remove file" color="#880000" style={{ cursor: "pointer", marginLeft: 10 }} onClick={() => this.removeAddAttachment(attachment)} />
                                                </p>
                                            );
                                        })
                                    }
                                    <input
                                        type="file"
                                        id="attachment-files"
                                        onClick={(e) => this.onFileClick(e)}
                                        onChange={(e) => this.getAttachments(e)}
                                        style={{ display: 'none' }}
                                        accept=".jpeg, .jpg, .png"
                                    />
                                    <button type="button" role="button" className="btn filesButton" onClick={this.getAttachmentClick}>
                                        <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" style={{ cursor: "pointer", marginRight: 10 }} />
                                        Choose Files
                                    </button>
                                    <p style={{ display: this.state.fileSelectionWarning.length > 0 ? 'block' : 'none', color: 'red' }}>{this.state.fileSelectionWarning}</p>
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type='checkbox'
                                        onChange={(event) => {
                                            this.setState({
                                                SpecimenCopy: event.target.checked, // Set true or false based on checkbox state
                                            });
                                        }}
                                        checked={this.state.SpecimenCopy}
                                        disabled={this.state.MarkAsDonated}
                                        style={{ marginRight: 5 }}
                                    /><label className='fs-14 fieldHeadColor '>Check here if it is specimen copy</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 pl-4 pt-2'>
                        <p className='fs-16 pb-1 fw-600' style={{ color: '#0465AC' }}>Invoice Details</p>
                        <div className='d-flex pb-3'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Invoice/Bill No.</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={Object.values(this.state.GetInvoiceDataList).map((item) => ({
                                            label: buildInvoiceLabel(item),          // short text
                                            title: buildInvoiceLabel(item, true),    // full text for hover
                                            value: item.billno,
                                            invoiceId: item.value
                                        }))}
                                        value={this.state.InvoiceBillNo}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                InvoiceBillNo: event || [], // Handle empty selection
                                            }, () => {
                                                this.GetLibraryInvoiceDate(this.state.InvoiceBillNo)
                                            });
                                        }}
                                        isDisabled={this.state.MarkAsDonated}
                                        placeholder="Select Invoice/Bill No"
                                        isClearable
                                        isLoading={this.state.loadingInvoiceData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingInvoiceData ? "Loading..." : "No options found")}
                                        formatOptionLabel={(option) => (
                                            <span title={option.title}>
                                                {option.label}
                                            </span>
                                        )}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Invoice/ Bill Date</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                        placeholder="Select Bill Date"
                                        value={this.state.InvoiceBillDate}
                                        onChange={(event) => {
                                            const selectedDate = event.target.value;

                                            if (selectedDate) {
                                                const year = selectedDate.split("-")[0];
                                                if (year.length === 4 && !isNaN(parseInt(year))) {
                                                    this.setState({
                                                        InvoiceBillDate: selectedDate,
                                                        invoiceDateWarning: "" // clear any previous error
                                                    });
                                                } else {
                                                    this.setState({
                                                        invoiceDateWarning: "Year must be a 4-digit number.",
                                                        InvoiceBillDate: ''
                                                    });
                                                }
                                            } else {
                                                this.setState({
                                                    InvoiceBillDate: '',
                                                    invoiceDateWarning: ''
                                                });
                                            }
                                        }}
                                        disabled={this.state.MarkAsDonated}
                                    />
                                </div>
                                {this.state.invoiceDateWarning && (
                                    <p style={{ color: 'red', fontSize: 12 }}>{this.state.invoiceDateWarning}</p>
                                )}
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Price <p style={{ color: '#7A7A7A', fontSize: '12px', display: 'inline', margin: '0' }}> (in ₹)</p></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="number"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Price"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.Price} // Bind value to state
                                        onChange={(event) => {
                                            const value = event.target.value;
                                            // Check if value is empty or a valid decimal number (up to 2 decimals).
                                            if (value === '' || (/^\d+(\.\d{1,2})?$/.test(value) && parseInt(value) > 0)) {
                                                this.setState({
                                                    Price: value,
                                                    priceWarning: ''
                                                }, () => {
                                                    this.calculateNetPrice(this.state.Price);
                                                });
                                            } else {
                                                this.setState({ priceWarning: "" })
                                            }
                                        }}

                                        disabled={this.state.MarkAsDonated}
                                    />
                                </div>
                                <p style={{ display: this.state.priceWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.priceWarning}</p>
                            </div>
                        </div>
                        <div className='d-flex pb-3'>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Discount <p style={{ color: '#7A7A7A', fontSize: '12px', display: 'inline', margin: '0' }}>(in %)</p></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="number"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Discount"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.Discount} // Bind value to state
                                        // onChange={(event) => {
                                        //     this.setState({
                                        //         Discount: event.target.value || '', // Handle empty selection
                                        //     }, () => {
                                        //         this.calculateNetPrice(this.state.Discount)
                                        //     });
                                        // }}
                                        onChange={(event) => {
                                            const value = event.target.value;
                                            // Check if value is empty or a valid decimal number (up to 2 decimals).
                                            if (value === '' || (/^\d+(\.\d{1,2})?$/.test(value) && parseInt(value) > 0)) {
                                                this.setState({
                                                    Discount: value,
                                                    priceWarning: ''
                                                }, () => {
                                                    this.calculateNetPrice(this.state.Discount);
                                                });
                                            }
                                        }}
                                        disabled={this.state.MarkAsDonated}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Net Price <p style={{ color: '#7A7A7A', fontSize: '12px', display: 'inline', margin: '0' }}>(in ₹ Per Copy)</p></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="number"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Net Price"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.CopyNetPrice} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                CopyNetPrice: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Net Price <p style={{ color: '#7A7A7A', fontSize: '12px', display: 'inline', margin: '0' }}>(in ₹ For Total Copies)</p></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="number"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Net Price"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.TotalCopiesNetPrice} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                TotalCopiesNetPrice: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* footer */}
                    <div className="modal-footer pt-5">
                        {this.state.addResourceLoading ? <ButtonLoader /> : null}
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddResource()}>Cancel</button>
                        <button className="btn btn-primary" onClick={() => this.validateResourceSubmission()} disabled={this.state.addResourceLoading}>Add Resource</button>
                    </div>
                </div>
            </div>
        );
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
        this.setState({ dataHideWhileExporting: true })
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            exportSelectedCSVHeaders.push(csvInfo);
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // EXPORT TABLE TO CSV
    tableToCSV = () => {
        // Creating csv string with headers
        let csvString = `\n "Accession Series*", "Accession Number*", "Accession Date", "Call Number", "Title*", "Author Name*", "Resource Volume", "Resource Edition", "Resource Language*", "Publisher*", "Number of Pages", "Number of Preliminary Pages", "Resource Category*", "Year of Publication", "Department", "Resource Type*", "Translator Name", "Translated", "Search Keyword", "Resource Medium", "Location", "ISBN Number", "Resource Condition", "Invoice/Bill No", "Invoice/ Bill Date", "Price (In Rs)", "Discount (In %)", "Net Price (In Rs)"\n`;

        // Adding sample hard-coded data
        const sampleData = [
            [
                "ACCSR1", "1", "2022-07-13", "CD:56:TPY",
                "The Power of your Subconscious Mind", "Dr. Murphy Joseph", "1", "1",
                "English", "Amazing Reads", "312", "5", "Self-Help Book", "2018",
                "Art", "General", "", "No", "", "Physical", "Shelf 2.4",
                "9788192910963", "Good", "67", "2018-07-13", "140", "0", "140"
            ],
            [
                "ACCSR2", "2", "2020-07-13", "CD:56:GVG",
                "Good Vibes Good Life", "Vex King", "1", "1",
                "English", "Hay House UK Ltd", "304", "5", "Self-Help Book", "2020",
                "Art", "General", "", "No", "", "Physical", "Shelf 5.4",
                "9781788171823", "Good", "123", "2020-07-13", "195", "0", "195"
            ]
        ];

        // Adding each row of sample data to csvString
        sampleData.forEach(row => {
            csvString += `"${row.join('","')}"\n`;
        });

        if (csvString !== '') {
            var downloadLink = document.createElement('a');
            downloadLink.download = "sample-Resource-details.csv";
            downloadLink.href = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(csvString);
            downloadLink.target = '_blank';
            document.getElementById('exportList').appendChild(downloadLink);
            downloadLink.click();
        }
    }

    // close import modal for Resources
    closeImportModalForResources = () => {
        this.setState({
            isShowImportResourceButton: false
        })
    }

    // METHOD TO CLOSE DELETE MODAL
    closeDeleteResources = () => {
        this.setState({
            deleteResources: false,
            deletingResources: false,
            deleteSingleResources: false,
            singleResourceData: {}
        });
    }

    // METHOD TO CHECK ACCESS FOR DELETE OPERATION
    checkDeleteAccess = () => {

        const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['resource'].find(access => access === 'delete');

        if (deleteGrantAccess !== undefined) {
            this.setState({
                deleteResources: true
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // API CALL METHOD TO DELETE RECEIPT
    apiCallToDeleteResources = async () => {
        this.setState({
            deletingResources: true
        });

        let requestData = {
            'iid': config.institute_id,
            'facultyId': config.faculty_id,
            'unique_idArray': this.state.selectedRows,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'DeleteMultipleLibraryResource',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeleteResources();
            }, 1000);
        } else {
            let apiResult = jsonResponse.APIResult;

            if (apiResult.status == 'success') {
                this.closeDeleteResources();

                this.GetLibraryResourceBasicDetailsList();

                toast.success(this.stripHtml(apiResult.message), {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

                this.setState({
                    deletingResources: false,
                    selectedRows: []
                });


            } else {
                this.setState({
                    deletingResources: false
                });

                toast.warn(this.stripHtml(apiResult.message), {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    actionHandleChange = (key) => {

        const hasDifferentIID = new Set(selectedCheckboxIID).size > 1;

        if (hasDifferentIID) {
            this.setState({ selectedRows: [] })
            toast.warn("Please select resources from the same Institute to perform this action.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            if (key === 'actionDeleteResources') {
                this.checkDeleteAccess()
            } else {
                this.setState({
                    updateMultipleActionModal: true,
                    resourceSearchIID: selectedCheckboxIID[0]
                }, () => {
                    this.apiCallToGetAccessionSeries()
                    this.apiCallToGetInstituteStreamList()
                    this.getPublisherList()
                    this.GetLibraryResourceCategoryListWithBasicDetails()
                    this.GetLibraryLocationList()
                    this.apiCallToGetAllDonorsList()
                    this.getLibraryInvoiceListDataStatus()
                });
            }
        }
    }

    // DELETE Single Resource
    deleteSingleResourceModal = (resourceData) => {
        const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['resource'].find(access => access === 'delete');

        if (deleteGrantAccess !== undefined) {
            this.setState({
                deleteSingleResources: true, singleResourceData: resourceData
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // API CALL METHOD TO DELETE Single Resource
    apiCallToDeleteSingleResource = async () => {
        this.setState({
            deletingResources: true
        });

        let requestData = {
            'iid': config.institute_id,
            'facultyId': config.faculty_id,
            'unique_id': this.state.singleResourceData.uniqueId,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'DeleteLibraryResource',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeleteSingleResource();
            }, 1000);
        } else {
            let apiResult = jsonResponse.APIResult;

            if (apiResult.status == 'success') {
                this.closeDeleteResources();

                toast.success(this.stripHtml(apiResult.message), {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

                this.setState({
                    singleResourceData: {},
                    deletingResources: false,
                });

                this.GetLibraryResourceBasicDetailsList();

            } else {
                this.setState({
                    deletingResources: false
                });
                toast.warn(this.stripHtml(apiResult.message), {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // API CALL METHOD TO GET DEPARTMENT LIST
    getInstituteStreamsObject = async () => {

        this.setState({
            loadingStreamData: true
        });

        let addResourceIID = '';
        if (this.state.addResourceInstituteIID.length > 0) {
            addResourceIID = this.state.addResourceInstituteIID[0].value
        } else {
            addResourceIID = this.state.addResourceInstituteIID.value
        }

        let requestData = {
            "iid": this.state.typeOfIIDScreen == 'Add' ? addResourceIID : this.state.resourceSearchIID
            // "limit": this.state.limit,
            // "page_index": this.state.pageIndex,

        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getInstituteStreamsObject();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let formattedData = Object.entries(apiResult).map(([sid, details]) => ({
                    sid,
                    name: details.stream_name
                }));

                this.setState({
                    GetStreamList: formattedData,
                    filterDepartmentData: apiResult,
                    loadingStreamData: false
                });

            }
        }
    }

    // VIEW Single Resource
    viewSingleResourceDetails = (resourceData) => {
        this.setState({
            viewSingleResources: true, singleResourceData: resourceData
        });
    }

    // EDIT Resource
    editResourceDetails = (resourceData) => {
        this.setState({
            editResources: true, singleResourceData: resourceData, addResourceInstituteIID: { value: resourceData.resourceIID }, typeOfIIDScreen: 'Add'
        }, () => {
            this.apiCallToGetAccessionSeries()
            // this.apiCallToGetInstituteStreamList()
            this.getInstituteStreamsObject()
            this.getPublisherList()
            this.GetLibraryResourceCategoryListWithBasicDetails()
            this.GetLibraryLocationList()
            this.apiCallToGetAllDonorsList()
            this.getLibraryInvoiceListDataStatus()
        }
        );
    }

    // Add Resource Copies
    addResourceCopies = (resourceData) => {
        this.setState({
            resourceCopiesModal: true, singleResourceData: resourceData, addResourceInstituteIID: { value: resourceData.resourceIID }, typeOfIIDScreen: 'Add'
        }, () => {
            this.apiCallToGetAccessionSeries()
        });
    }

    // Accession series modal
    accessionSeriesModalDetails = (resourceData) => {
        this.setState({
            accessionSeriesModal: true
        });
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    render() {

        // get selected row iid
        selectedCheckboxIID = this.state.selectedRows.map(id => {
            const item = this.state.resourceDetailsList[id];
            return item ? item.resourceIID : null;
        }).filter(id => id !== null)


        // display applied filters while exporting data
        let FilterArray = [];

        let filterResourceTitle = this.state.resourceSearchTitle
        let filterResourceAuthor = this.state.resourceSearchAuthor
        let filterAccessionNumber = this.state.resourceSearchAccessionNumber
        let filterInstitute = Object.values(this.state.linkedInstituteArray).find(item => item.iid == this.state.resourceSearchIID);

        let filterAccessionSeries = this.state.resourceSearchAccessionSeries
        let filterMultipleAccessionNumber = this.state.searchMultipleAccessionNumber
        let filterAccessionNumberFrom = this.state.searchAccessionNumberFrom
        let filterAccessionNumberTo = this.state.searchAccessionNumberTo
        let filterDepartment = this.state.departmentAdvanceFilterValue
        let filterResourceCategory = this.state.categoryAdvanceFilterValue
        let filterLocation = this.state.locationAdvanceFilterValue
        let filterResourceType = this.state.typeAdvanceFilterValue
        let filterResourceStatus = this.state.statusAdvanceFilterValue
        let filterIsDonated = this.state.isDonated

        if (filterResourceTitle) {
            FilterArray.push(`Resource Title - ${filterResourceTitle}`)
        }
        if (filterResourceAuthor) {
            FilterArray.push(`Resource Author - ${filterResourceAuthor}`)
        }
        if (filterInstitute) {
            FilterArray.push(`Institute - ${filterInstitute.institute_name}`)
        }
        if (filterAccessionNumber) {
            FilterArray.push(`Accession Number - ${filterAccessionNumber}`)
        }

        if (this.state.resourceSearchAccessionSeries && filterAccessionSeries.length > 0) {
            FilterArray.push(`Accession Series - ${filterAccessionSeries?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchMultipleAccessionNumber && filterMultipleAccessionNumber.length > 0) {
            FilterArray.push(`Multiple Accession Number - ${filterMultipleAccessionNumber?.map(item => item.label).join(", ")}`)
        }
        if (filterAccessionNumberFrom) {
            FilterArray.push(`Accession Number From - ${filterAccessionNumberFrom}`)
        }
        if (filterAccessionNumberTo) {
            FilterArray.push(`Accession Number To - ${filterAccessionNumberTo}`)
        }
        if (this.state.departmentAdvanceFilterValue && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment?.map(item => item.label).join(", ")}`)
        }
        if (this.state.categoryAdvanceFilterValue && filterResourceCategory.length > 0) {
            FilterArray.push(`Resource Category - ${filterResourceCategory?.map(item => item.label).join(", ")}`)
        }
        if (this.state.locationAdvanceFilterValue && filterLocation.length > 0) {
            FilterArray.push(`Location - ${filterLocation?.map(item => item.label).join(", ")}`)
        }
        if (this.state.typeAdvanceFilterValue && filterResourceType.length > 0) {
            FilterArray.push(`Resource Type - ${filterResourceType?.map(item => item.label).join(", ")}`)
        }
        if (this.state.statusAdvanceFilterValue && filterResourceStatus.length > 0) {
            FilterArray.push(`Resource Status - ${filterResourceStatus?.map(item => item.label).join(", ")}`)
        }
        if (filterIsDonated) {
            FilterArray.push(`Donated Resources - ${this.state.isDonated ? 'Donated' : 'Not-Donated'}`)
        }
        return (
            <>
                <RoutingMenu activeScreen="resource" />
                <div className="ResourceDetailsContainer">
                    <div className='resourceHeader'>
                        <p className='vm_custom_title3' style={{ color: '#000000' }}>Library Resources</p>
                        <a href={config.RootUrl + "/modules/library/#/resource"}>
                            <span
                                style={{
                                    width: 'auto',
                                    borderRadius: '20px',
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #ccc',
                                    padding: '6px',
                                    fontFamily: "'Poppins', sans-serif",
                                    fontSize: '12px',
                                    marginRight: '5px',
                                }}
                            >
                                Switch To Old Resource  Version
                            </span>
                        </a>
                        <div className='d-flex col-md justify-content-end'>
                            <button type="button" onClick={() => this.addOrEditResourceModal()} style={{ fontSize: '10px !important' }} className="btn btn-primary br-5">
                                <FontAwesomeIcon size='sm' icon={["fa", "plus"]} /> &nbsp;
                                <span className='fs-13'>Add Resource</span>
                            </button>
                            <button type="button" onClick={() => this.accessionSeriesModalDetails()} style={{ fontSize: '10px !important' }} className="btn btn-primary br-5">
                                <FontAwesomeIcon size='sm' icon={["fa", "list"]} /> &nbsp;
                                <span className='fs-13'>Accession Series</span>
                            </button>
                        </div>
                    </div>

                    <div>
                        <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                            <div style={{ width: '100%' }}>
                                {/* filter data form*/}
                                {/* <form style={{ width: '100%' }}> */}
                                <div className="taskContentRow" style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                        {/* Based On Resource Title */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Resource Title</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <img
                                                    src={searchPng}
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        color: '#ccc',
                                                        backgroundColor: 'white',
                                                        width: '18px',
                                                        height: '18px',
                                                        zIndex: 1,
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control formControlAutoTask"
                                                    id="resourceTitleFilterID"
                                                    placeholder="Search by Title "
                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px' }}
                                                    value={this.state.resourceSearchTitle} // Bind value to state
                                                    onChange={this.handleResourceTitleChange} // Handle input changes
                                                    onKeyPress={this.handleResourceTitleKeyPress} // Trigger API call on Enter
                                                />
                                            </div>
                                        </div>

                                        {/* Based On Resource Author */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Author</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <img
                                                    src={searchPng}
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        color: '#ccc',
                                                        backgroundColor: 'white',
                                                        width: '18px',
                                                        height: '18px',
                                                        zIndex: 1,
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control formControlAutoTask"
                                                    id="resourceAuthorFilterID"
                                                    placeholder="Search by Author"
                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px' }}
                                                    value={this.state.resourceSearchAuthor}
                                                    onChange={this.handleResourceAuthorChange} // Handle input changes
                                                    onKeyPress={this.handleResourceAuthorKeyPress} // Trigger API call on Enter
                                                />
                                            </div>
                                        </div>

                                        {/* Based on resource iid */}
                                        <div className="filteredInput mb-3 p-1">
                                            <label htmlFor="taskID" className="vm_custom_body10">Institute</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <select
                                                    className="form-control formControlContentTask"
                                                    style={{
                                                        width: 'auto',
                                                        height: '42px',
                                                        fontSize: "13px",
                                                        fontWeight: 400,
                                                        lineHeight: '20px',
                                                        fontFamily: "'Poppins', sans-serif",
                                                        color: '#808080',
                                                        borderRadius: '7px'
                                                    }}
                                                    id="resourceInstituteFilterID"
                                                    onChange={(e) => {
                                                        selectedCheckboxIID = [];
                                                        const selectedIID = e.target.value;

                                                        if (selectedIID) {
                                                            const numericIID = [selectedIID].map(Number);

                                                            this.setState(
                                                                {
                                                                    filterInstituteIID: numericIID,
                                                                    resourceSearchIID: selectedIID,
                                                                    pageIndex: 1,
                                                                    limit: "10",
                                                                    resourceSearchAccessionSeries: [],
                                                                    selectedRows: [],
                                                                },
                                                                () => {
                                                                    this.GetFilteredLibraryResourceList();

                                                                    this.getInstituteStreamsObject();  // department
                                                                    this.apiFilterGetAccessionSeries(); // accession series
                                                                    this.apiFilterLibraryLocationList();  // location list
                                                                    this.apiFilterLibraryResourceCategoryListWithBasicDetails();  // resource category
                                                                    this.apiFilterPublisherList();  // publisher list
                                                                    this.apiFilterLibraryResourceStatus();  // resource status                                                            
                                                                }
                                                            );

                                                        } else {

                                                            this.setState(
                                                                {
                                                                    filterInstituteIID: this.props.iidArray.iidArray,
                                                                    resourceSearchIID: '',
                                                                    pageIndex: 1,
                                                                    limit: "10",
                                                                    resourceSearchAccessionSeries: [],
                                                                    selectedRows: [],
                                                                },
                                                                () => {
                                                                    this.GetFilteredLibraryResourceList();

                                                                    this.apiFilterGetInstituteStreamList();  // department
                                                                    this.apiFilterGetAccessionSeries(); // accession series
                                                                    this.apiFilterLibraryLocationList();  // location list
                                                                    this.apiFilterLibraryResourceCategoryListWithBasicDetails();  // resource category
                                                                    this.apiFilterPublisherList();  // publisher list
                                                                    this.apiFilterLibraryResourceStatus();  // resource status
                                                                }
                                                            );
                                                        }



                                                    }}
                                                    value={this.state.filterInstituteIID} // Bind dropdown value to state
                                                >
                                                    <option value={""}>Select Institute</option>
                                                    {Object.values(this.state.multipleInstituteDetails).map((member) => (
                                                        <option key={member?.iid} value={member?.iid}>
                                                            {member?.institute_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* Based on accession number */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Accession Number</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <img
                                                    src={searchPng}
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        color: '#ccc',
                                                        backgroundColor: 'white',
                                                        width: '18px',
                                                        height: '18px',
                                                        zIndex: 1,
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control formControlAutoTask"
                                                    id="resourceAccessionNumberFilterID"
                                                    placeholder="Accession Number"
                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px' }}
                                                    value={this.state.resourceSearchAccessionNumber} // Bind value to state
                                                    onChange={this.handleResourceAccessionNoChange} // Handle input changes
                                                    onKeyPress={this.handleResourceAccessionNoKeyPress} // Trigger API call on Enter
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end align-items-center" style={{ marginTop: '15px', gap: '10px' }}>
                                        {/*Advance Filter Icon*/}
                                        <div id='advanceFilter' className="p-2" style={{ alignItems: "center", display: "flex" }}>
                                            {/* <div className="input-group input-group-field" style={{ position: 'relative', cursor: 'pointer' }} onClick={() => this.advanceFilterModal()}>
                                            <img src={AdvanceFilterIcon} alt='Advance Filter' style={{ height: "35px", width: "35px", marginTop: "10px" }} />
                                        </div> */}
                                            <button className="btn outline-button" style={{ borderRadius: '5px', boxShadow: 'none' }} onClick={() => this.advanceFilterModal()}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style>
                                                <FontAwesomeIcon size='lg' icon={faSlidersH} style={{ cursor: "pointer", color: '#0465AC' }} />
                                            </button>
                                        </div>

                                        {/* Click to Print */}
                                        <div title="Click to Print">
                                            <span className="print-button">
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return (
                                                            <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                <style type="text/css" media="print">
                                                                    {"@page { size: auto; }"}
                                                                </style>
                                                                <span>
                                                                    <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                </span>
                                                            </div>
                                                        )
                                                    }}
                                                    content={() => this.componentRef}
                                                />
                                            </span>
                                        </div>

                                        {/* Click to Import */}
                                        <div title="Click to Import">
                                            <button className="btn outline-button" id='exportDropdownMenu'
                                                style={{ borderRadius: '5px', boxShadow: 'none' }}
                                                onClick={() => {
                                                    this.setState({
                                                        isShowImportResourceButton: true
                                                    })
                                                }}> <style type="text/css" media="print">
                                                    {"@page { size: auto; }"}
                                                </style><FontAwesomeIcon size='lg' icon={["fa", "file-import"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>
                                        </div>

                                        {/* 1 action button - export data */}
                                        <div className="d-flex ml-2" title="Click to Export" >
                                            <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                            {/* 2.1 action button option - export and export all */}
                                            <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                <span>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="export"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="resourceList"
                                                            filename="LibraryResourceList"
                                                            sheet="tablexls"
                                                            buttonText="Export to Excel "
                                                        >
                                                        </ReactHTMLTableToExcel>
                                                    </div>
                                                    {/* <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="exportAll"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="ExportAllResourceLisAsPerAccessionNumberReport"   // export all functionality
                                                            filename="ExportAllResourceLisAsPerAccessionNumberReport"
                                                            sheet="tablexls"
                                                            buttonText="Export All to Excel"
                                                        />
                                                    </div> */}
                                                    <button
                                                        // onClick={this.formatCSVExportData}
                                                        onClick={() => {
                                                            this.setState({ dataHideWhileExporting: false }, () => {
                                                                this.formatCSVExportData()
                                                            })
                                                        }}
                                                        className="dropdown-item"
                                                        title="Click to Export"
                                                        style={{ boxShadow: 'none' }}
                                                    >
                                                        Export
                                                    </button>
                                                    {/* {this.state.isExportAllReportDataFetching ? (
                                                        <p className="dropdown-item">
                                                            Exporting report . . .&nbsp;
                                                            <FontAwesomeIcon
                                                                icon={["fas", "circle-notch"]}
                                                                className="rotate"
                                                            />
                                                        </p>
                                                    ) : (
                                                        <button
                                                            onClick={() => this.setState({ allReportData: {} }, () => {
                                                                this.methodToExportReportData(0)
                                                            })}
                                                            className="dropdown-item"
                                                            title="Click to Export All"
                                                            style={{ boxShadow: 'none' }}
                                                        >
                                                            Export All
                                                        </button>
                                                    )} */}
                                                </span>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                {/* </form> */}
                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Press "Enter" to get resource list filter result.</p>
                                {/* <div className='vm_custom_body5' style={{ marginLeft: "20px" }}>Press "Enter" to get resource list filter result.</div> */}
                            </div>
                        </div>

                        {
                            (this.state.resourceSearchTitle !== '' || this.state.resourceSearchAuthor !== '' || this.state.resourceSearchIID !== config.institute_id || this.state.resourceSearchAccessionSeries.length !== 0 || this.state.resourceSearchAccessionNumber !== ""
                                || this.state.pageIndex !== 1 || this.state.limit !== "10" || this.state.departmentAdvanceFilterValue.length !== 0 || this.state.categoryAdvanceFilterValue.length !== 0 || this.state.locationAdvanceFilterValue.length !== 0 || this.state.typeAdvanceFilterValue.length !== 0 || this.state.statusAdvanceFilterValue.length !== 0 || this.state.isDonated !== false
                                || this.state.searchMultipleAccessionNumber.length !== 0 || this.state.searchAccessionNumberFrom !== '' || this.state.searchAccessionNumberTo !== ''
                            ) &&
                            <div className='filter-apply'>
                                <p className='vm_custom_body5'>Filters are applied.</p>
                                <p className="clear-all vm_custom_body5" onClick={this.handleClearAllResourceFilter}>Clear All</p>
                            </div>
                        }
                    </div>

                    <div className="col-md-12 px-0 div_table">
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                            <div className="print-area" ref={el => this.componentRef = el}>
                                <div className="buildingReport_logo">
                                    <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                    <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                    <h3>Library Resources</h3>
                                    {
                                        FilterArray.join(" | ")
                                    }
                                </div>
                                <table className="table table-bordered  vm_libraryReport_table" id="resourceList">
                                    <thead style={{ backgroundColor: "#f2f3f4", position: 'sticky', top: '-1%' }}>
                                        {/* Hidden rows for titles, etc. */}
                                        <tr className='d-none'>
                                            <th colSpan="14" style={{ textAlign: 'center' }}>{config.institute_name}</th>
                                        </tr>
                                        <tr className='d-none'>
                                            <th colSpan="14" style={{ textAlign: 'center' }}>Library Resources</th>
                                        </tr>
                                        <tr className='d-none'>
                                            <th colSpan="14" style={{ textAlign: 'center' }}>
                                                {FilterArray.join(" | ")}
                                            </th>
                                        </tr>
                                        <tr className='d-none'>
                                            <th colSpan="14" ></th>
                                        </tr>

                                        {/* Column headers */}
                                        <tr>
                                            {this.state.dataHideWhileExporting &&
                                                <th className='vm_custom_body4 printHide' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>
                                                    <input
                                                        type='checkbox'
                                                        onChange={this.handleSelectAllCheckboxChange}
                                                        checked={
                                                            this.state.selectedRows.length === Object.values(this.state.resourceDetailsList).length &&
                                                            Object.values(this.state.resourceDetailsList).length > 0
                                                        }
                                                        style={{ marginRight: 5 }}
                                                    />
                                                </th>
                                            }
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Sr. No.</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Institute</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Accession Series</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Accession Number</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Title</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Medium</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Author</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Invoice Number</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Status</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Edition</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Resource Volume</th>
                                            <th className='vm_custom_body4' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Last Modified By</th>
                                            {this.state.dataHideWhileExporting && <th className='vm_custom_body4 printHide' style={{ backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Action</th>}
                                        </tr>

                                        {this.state.dataHideWhileExporting &&
                                            <>
                                                {/* Conditional action row */}
                                                {this.state.selectedRows.length > 0 && (
                                                    <tr className='printHide'>
                                                        <th
                                                            colSpan={13}
                                                            style={{
                                                                backgroundColor: "#eff7ff",
                                                                border: '0.93px solid #E0E8EF',
                                                                padding: '10px',
                                                                position: 'sticky',
                                                                top: 0,
                                                                zIndex: 2,
                                                            }}
                                                        >
                                                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-start' }}>
                                                                {/* Update multiple action button */}
                                                                <button className="uploadButton" id='actionDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true">
                                                                    Action <FontAwesomeIcon size='lg' icon={["fa", "sort-down"]} style={{ cursor: "pointer" }} />
                                                                </button>
                                                                <div className="dropdown-menu  vm-dropdown-menu" aria-labelledby='actionDropdownMenu' style={{
                                                                    maxHeight: '250px',  // Set your desired height
                                                                    overflowY: 'auto',
                                                                    boxShadow: '4px 4px 10px #b7adad'
                                                                }}>
                                                                    {
                                                                        this.state.itemVisibilityForRows.map((columnInfo, index) => {
                                                                            return (
                                                                                <p className="dropdown-item"
                                                                                    style={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center', // Vertical center alignment
                                                                                        fontSize: '14px',
                                                                                        cursor: 'pointer',
                                                                                        padding: '8px 10px',
                                                                                        marginBottom: '3px',
                                                                                        gap: '6px'
                                                                                    }} key={columnInfo.name} onClick={() => this.setState({ actionButtonTitle: columnInfo.name }, () => {
                                                                                        this.actionHandleChange(columnInfo.key)
                                                                                    })
                                                                                    }>
                                                                                    <FontAwesomeIcon size='lg' icon={columnInfo.icon} style={{ cursor: "pointer" }} />
                                                                                    <span>{columnInfo.name}</span>
                                                                                </p>
                                                                            );
                                                                        })
                                                                    }
                                                                </div>
                                                                {/* Import Bulk Update */}
                                                                <button
                                                                    className="uploadButton"
                                                                    // onClick={() => this.setState(this.GetLibraryMultipleResourcesDetails())}
                                                                    onClick={() => {
                                                                        const hasDifferentIID = new Set(selectedCheckboxIID).size > 1;
                                                                        if (hasDifferentIID) {
                                                                            this.setState({ selectedRows: [] })
                                                                            toast.warn("Please select resources from the same Institute to perform this action.", {
                                                                                position: "top-right",
                                                                                autoClose: 2000,
                                                                                hideProgressBar: false,
                                                                                closeOnClick: true,
                                                                                pauseOnHover: true,
                                                                                draggable: true,
                                                                                progress: undefined,
                                                                            });
                                                                        } else {
                                                                            this.setState({ resourceSearchIID: selectedCheckboxIID[0] }, () => {
                                                                                this.GetLibraryMultipleResourcesDetails()
                                                                                this.getInstituteStreamsObject();  // department
                                                                                this.apiCallToGetAccessionSeries(); // accession series
                                                                                this.GetLibraryLocationList();  // location list
                                                                                this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
                                                                                this.getPublisherList();  // publisher list
                                                                                this.getLibraryResourceStatus();  // resource status
                                                                                this.getLibraryInvoiceListDataStatus();  // invoice data
                                                                                this.apiCallToGetDonorsList();  // donor data
                                                                            })
                                                                        }
                                                                    }}
                                                                >
                                                                    <span style={{ display: "flex", flexDirection: "row", gap: '5px' }}>
                                                                        <p>Import Bulk Update</p>
                                                                        {this.state.loadingMultipleResourcesData && <ButtonLoader />}
                                                                    </span>
                                                                </button>
                                                                {/* Add/Update Donor */}
                                                                <button className="uploadButton" onClick={this.updateDonorModalOpen}>
                                                                    <span style={{ display: "flex", flexDirection: "row", gap: '5px' }}>
                                                                        <p>Add/Update Donor</p>
                                                                    </span>
                                                                </button>
                                                                {/* Set Parent Resource */}
                                                                <button className="uploadButton" onClick={this.updateUpdateParentResourceModalOpen}>
                                                                    <span style={{ display: "flex", flexDirection: "row", gap: '5px' }}>
                                                                        <p>Set Parent Resource</p>
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                )}
                                            </>
                                        }
                                    </thead>

                                    <tbody>
                                        {
                                            this.state.resourceListLoading ? <tr>
                                                <td colSpan="14">
                                                    <ButtonLoader />
                                                </td>
                                            </tr> :
                                                this.state.sortedIdArray.length > 0 ?
                                                    this.state.sortedIdArray.map((resourceId, index) => {
                                                        let resource = this.state.resourceDetailsList[resourceId];

                                                        return (

                                                            <tr key={index}>
                                                                {this.state.dataHideWhileExporting &&
                                                                    <td className="table-rows vm_custom_body5 printHide" style={{ border: '1.01px solid #E0E8EF' }}><input type='checkbox' onChange={() => this.handleCheckboxChange(resource.uniqueId)} checked={this.state.selectedRows.includes(resource.uniqueId)} /></td>
                                                                }
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{
                                                                    this.state.limit === 'all' ? index + 1 :
                                                                        ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                }</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.resourceInstituteName}</p>}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.AccessionText} |{" "}
                                                                    {resource.parentid == 0 ? "Parent resource" : "Copy resource"}</p>}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.accessionnumber}</p>}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }} title={resource.title}>{<p>{resource.title}</p>}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.medium}</p>}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }} title={resource.author}>{<p>{resource.author}</p>}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>
                                                                    {resource.billno}{resource.vendor ? ` - ${resource.vendor}` : ''}
                                                                </p>}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.resource_status ? resource.resource_status.charAt(0).toUpperCase() + resource.resource_status.slice(1) : ''}</p>}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.edition}</p>}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF' }}>{<p>{resource.volume}</p>}</td>
                                                                <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF', padding: "5px", cursor: "pointer", color: resource.uniqueId == this.state.hoverID ? "#0465AC" : "" }}
                                                                    onMouseEnter={() => this.setState({ hoverID: resource.uniqueId })}
                                                                    onMouseLeave={() => this.setState({ hoverID: "" })}
                                                                    onClick={() => this.openActivitySlider(resource.uniqueId)}>
                                                                    {resource.updated_by_Name ? (
                                                                        <div className="d-flex flex-column">
                                                                            <div>{resource.updated_by_Name} ({resource.last_updated_by_ERP}) | {resource.updatedOn}</div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="d-flex flex-column">
                                                                            <div>{resource.added_by_name} ({resource.added_by_ERP}) | {resource.addedOn}</div>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                {this.state.dataHideWhileExporting &&
                                                                    <td className="table-rows vm_custom_body5 printHide" style={{ border: '1.01px solid #E0E8EF', padding: '1.5rem' }}>
                                                                        <FontAwesomeIcon icon={['far', 'edit']} size="lg" title="Click to edit resource" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => this.editResourceDetails(resource)} />
                                                                        <FontAwesomeIcon icon={['far', 'trash-alt']} size="lg" title="Click to delete resource" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => this.deleteSingleResourceModal(resource)} />
                                                                        <FontAwesomeIcon icon={['far', 'eye']} size="lg" title="Click to view resource details" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => this.viewSingleResourceDetails(resource)} />
                                                                        <FontAwesomeIcon icon={['fas', 'plus']} size="lg" title="Click to add the copies" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => { this.addResourceCopies(resource) }} />
                                                                    </td>
                                                                }
                                                            </tr>
                                                        )
                                                    }) :
                                                    <tr>
                                                        <td colSpan="14">
                                                            No data found.
                                                        </td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {
                            (Object.keys(this.state.resourceDetailsList).length > 0 || Object.keys(this.state.resourceDetailsList).length > this.state.limit) &&
                            <div className='row px-0'>
                                <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                            <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                    <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={this.resetResourcePerPageList}>
                                                        <option value={10}>Entries Per Page 10</option>
                                                        <option value={25}>Entries Per Page 25</option>
                                                        <option value={40}>Entries Per Page 40</option>
                                                        <option value={100}>Entries Per Page 100</option>
                                                        <option value={250}>Entries Per Page 250</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                            <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                <Pagination
                                                    activePage={this.state.pageIndex}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.totalResourcesItems}
                                                    pageRangeDisplayed={3}
                                                    onChange={this.handleResourcePageChange}
                                                />
                                            </div>
                                        </div>
                                        {/* {
                                            this.returnExportAllData()
                                        } */}
                                        <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                            <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                Total Records : {this.state.totalResourcesItems || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    {this.state.openBulkUpdateResourceModal &&
                        <ImportBulkUpdateResources
                            openBulkUpdateResourceModal={this.state.openBulkUpdateResourceModal}
                            streamListData={this.state.GetStreamList}
                            accessionSeriesListData={this.state.accessionSeriesList}
                            locationListData={this.state.GetLocationList}
                            resourceCategoryData={this.state.GetResourceCategoryList}
                            publisherData={this.state.GetPublisherList}
                            resourceStatusData={this.state.GetResourceStatusList}
                            invoiceData={this.state.GetInvoiceDataList}
                            multipleResourcesDetails={this.state.multipleResourcesDetails}
                            resourceSearchIID={this.state.resourceSearchIID}
                        />
                    }
                    {
                        this.returnAdvanceFilterModelData()
                    }
                    {
                        this.returnUpdateDonors()
                    }
                    {
                        this.returnUpdateParentResource()
                    }
                    {
                        this.returnAddResource()
                    }
                    {this.state.isShowImportResourceButton &&
                        <ImportResource
                            export={this.tableToCSV}
                            isShowImportResourceButton={this.state.isShowImportResourceButton}
                            closeImportModalForResources={this.closeImportModalForResources}
                            locationListData={this.state.GetLocationList}
                            resourceCategoryData={this.state.GetResourceCategoryList}
                            streamListData={this.state.GetStreamList}
                            accessionSeriesListData={this.state.accessionSeriesList}
                            publisherData={this.state.GetPublisherList}
                            invoiceData={this.state.GetInvoiceDataList}
                        />
                    }
                    {
                        this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal}
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal}
                        />
                    }
                    {
                        this.state.deleteResources &&
                        <DeleteModal
                            showModal={this.state.deleteResources}
                            visibility={this.closeDeleteResources}
                            deleteKey='Resources'
                            deleteComponent={this.apiCallToDeleteResources}
                            buttonDisable={this.state.deletingResources}
                        />
                    }
                    {
                        this.state.updateMultipleActionModal &&
                        <UpdateMultipleAction
                            updateMultipleAction={this.state.updateMultipleActionModal}
                            onClose={() => this.setState({ updateMultipleActionModal: false })}
                            modalTitle={this.state.actionButtonTitle}
                            accessionSeriesListData={this.state.accessionSeriesList}
                            locationListData={this.state.GetLocationList}
                            resourceCategoryData={this.state.GetResourceCategoryList}
                            resourceTypeData={resourceTypeData}
                            invoiceData={this.state.GetInvoiceDataList}
                            resourceStatusData={this.state.GetResourceStatusList}
                            resourceLanguageData={resourceLanguageData}
                            donorsListData={this.state.allDonorData}
                            publisherData={this.state.GetPublisherList}
                            streamListData={this.state.GetStreamList}
                            SelectedResourcesIdArray={this.state.selectedRows}
                            resourceSearchIID={this.state.resourceSearchIID}
                            iidArray={this.props.iidArray.iidArray}
                        />
                    }
                    {/* modal for single resource delete */}
                    {
                        this.state.deleteSingleResources &&
                        <DeleteModal
                            showModal={this.state.deleteSingleResources}
                            visibility={this.closeDeleteResources}
                            deleteKey='Resource'
                            deleteComponent={this.apiCallToDeleteSingleResource}
                            buttonDisable={this.state.deletingResources}
                        />
                    }
                    {/* modal for single resource data view */}
                    {
                        this.state.viewSingleResources &&
                        <ViewResourceDetails
                            viewSingleResources={this.state.viewSingleResources}
                            onClose={() => this.setState({ viewSingleResources: false, singleResourceData: {} })}
                            ResourceData={this.state.singleResourceData}
                        />
                    }
                    {/* modal for edit resource data */}
                    {
                        this.state.editResources &&
                        <EditResourceDetails
                            editResourceData={this.state.editResources}
                            onClose={() => this.setState({ editResources: false, singleResourceData: {} })}
                            ResourceData={this.state.singleResourceData}
                            accessionSeriesListData={this.state.accessionSeriesList}
                            resourceLanguageData={resourceLanguageData}
                            publisherData={this.state.GetPublisherList}
                            resourceCategoryData={this.state.GetResourceCategoryList}
                            streamListData={this.state.GetStreamList}
                            resourceTypeData={resourceTypeData}
                            locationListData={this.state.GetLocationList}
                            resourceConditionData={resourceConditionData}
                            invoiceData={this.state.GetInvoiceDataList}
                            resourceStatusData={this.state.GetResourceStatusList}
                            donorsListData={this.state.allDonorData}
                        />
                    }
                    {/* modal for add accession series */}
                    {
                        this.state.accessionSeriesModal &&
                        <AddAccessionSeries
                            accessionSeriesModal={this.state.accessionSeriesModal}
                            onClose={() => this.setState({ accessionSeriesModal: false })}
                            accessionSeriesListData={this.state.accessionSeriesList}
                        />
                    }
                    {/* modal for add resource copies */}
                    {
                        this.state.resourceCopiesModal &&
                        <AddResourceCopies
                            resourceCopiesModal={this.state.resourceCopiesModal}
                            onClose={() => this.setState({ resourceCopiesModal: false })}
                            accessionSeriesListData={this.state.accessionSeriesList}
                            ResourceData={this.state.singleResourceData}
                        />
                    }
                    {
                        this.state.showActivitySlider && this.state.selectedIid != "" &&
                        <SpecificUserLog
                            showSlider={this.state.showActivitySlider}
                            closeSlider={this.closeActivitySlider}
                            logUid={this.state.selectedIid}
                            activityArr={['Resource_added', "resource_updated", "resourceCopy_added", "resource_deleted", "resourceCopy_updated",
                                "resources_updated", "library_resources_updated", "resources_deleted"]}
                        />
                    }
                </div >
            </>
        );
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
    };
};

export default connect(mapStateToProps)(ResourceDetails);

// export default ResourceDetails;